const jhsfrenchQuestions = [
  {
    question: "Quelle est la nationalité d'une personne qui vient de la France?",
    options: ["Français(e)", "Anglais(e)", "Ghanéen(ne)", "Espagnol(e)"],
    answer: "Français(e)"
  },
  {
    question: "Comment dit-on 'Good morning' en français?",
    options: ["Bonsoir", "Bonjour", "Bonne nuit", "Salut"],
    answer: "Bonjour"
  },
  {
    question: "Quel est le verbe être au présent pour 'je'?",
    options: ["es", "suis", "est", "sommes"],
    answer: "suis"
  },
  {
    question: "Choisissez le mot correct: 'Elle ___ une voiture.'",
    options: ["as", "ont", "a", "avons"],
    answer: "a"
  },
  {
    question: "Quel est l'article défini pour 'école'?",
    options: ["le", "la", "les", "l’"],
    answer: "l’"
  },
  {
    question: "Quel mot est un nom?",
    options: ["manger", "livre", "courir", "aller"],
    answer: "livre"
  },
  {
    question: "Comment dit-on 'teacher' en français?",
    options: ["étudiant", "enseignant", "docteur", "avocat"],
    answer: "enseignant"
  },
  {
    question: "Complétez: 'Il ___ au marché.'",
    options: ["allez", "vas", "va", "vais"],
    answer: "va"
  },
  {
    question: "Quel pronom remplace 'Marie et moi'?",
    options: ["ils", "vous", "nous", "elles"],
    answer: "nous"
  },
  {
    question: "Quel est le féminin de 'acteur'?",
    options: ["actrice", "acteur", "acteuse", "acteuse"],
    answer: "actrice"
  },
  // Continue up to 50
  {
    question: "Comment dit-on 'book' en français?",
    options: ["stylo", "papier", "livre", "chaise"],
    answer: "livre"
  },
  {
    question: "Quelle est la couleur du drapeau français?",
    options: ["Rouge, Vert, Jaune", "Bleu, Blanc, Rouge", "Noir, Blanc, Vert", "Rouge, Blanc, Jaune"],
    answer: "Bleu, Blanc, Rouge"
  },
  {
    question: "Quel verbe signifie 'to eat'?",
    options: ["parler", "écouter", "manger", "boire"],
    answer: "manger"
  },
  {
    question: "Le contraire de 'grand' est:",
    options: ["petit", "beau", "vieux", "joli"],
    answer: "petit"
  },
  {
    question: "Comment dit-on 'I am tired' en français?",
    options: ["Je suis fatigué", "Je suis heureux", "Je suis content", "Je suis malade"],
    answer: "Je suis fatigué"
  },
  {
    question: "Quelle est la bonne conjugaison de 'avoir' pour 'tu'?",
    options: ["as", "ai", "a", "avez"],
    answer: "as"
  },
  {
    question: "Quel jour vient après 'mardi'?",
    options: ["lundi", "mercredi", "jeudi", "dimanche"],
    answer: "mercredi"
  },
  {
    question: "Complétez: 'Nous ___ des étudiants.'",
    options: ["sommes", "êtes", "sont", "es"],
    answer: "sommes"
  },
  {
    question: "Quelle est la bonne traduction de 'chair'?",
    options: ["chaise", "table", "lit", "bureau"],
    answer: "chaise"
  },
  {
    question: "Quel pronom sujet remplace 'le professeur'?",
    options: ["il", "elle", "vous", "tu"],
    answer: "il"
  },
  {
    question: "Quel est le pluriel de 'animal'?",
    options: ['animales', 'animaux', 'animals', 'animes'],
    answer: "animaux"
  },
  {
    question: "Comment dit-on 'I have a pen' en français?",
    options: ['J’ai un livre', 'J’ai une gomme', 'J’ai un stylo', 'J’ai une règle'],
    answer: "J’ai un stylo"
  },
  {
    question: "Quel mot est un adjectif?",
    options: ['vite', 'beau', 'parler', 'arbre'],
    answer: "beau"
  },
  {
    question: "Quel est le verbe 'être' à la 3ème personne du pluriel?",
    options: ['es', 'sont', 'sommes', 'êtes'],
    answer: "sont"
  },
  {
    question: "Comment appelle-t-on une femme médecin en français?",
    options: ['infirmière', 'docteure', 'doctoresse', 'médecin'],
    answer: "médecin"
  },
  {
    question: "Quel mot est un verbe?",
    options: ['maison', 'bleu', 'chanter', 'livre'],
    answer: "chanter"
  },
  {
    question: "Comment dit-on 'I am going to school'?",
    options: ['Je vais à l’école', 'Je suis à la maison', 'Tu vas au marché', 'Nous allons à la plage'],
    answer: "Je vais à l’école"
  },
  {
    question: "Complétez: 'Il ___ une pomme.'",
    options: ['mangent', 'mange', 'manges', 'mangeons'],
    answer: "mange"
  },
  {
    question: "Le mot 'rouge' est:",
    options: ['un verbe', 'un nom', 'un adjectif', 'un pronom'],
    answer: "un adjectif"
  },
  {
    question: "Quel est le féminin de 'étudiant'?",
    options: ['étudiante', 'étudienne', 'étudiée', 'étudier'],
    answer: "étudiante"
  },
  {
    question: "Quel est l’infinitif du verbe 'mange'?",
    options: ["mangir", "manger", "mangé", "manges"],
    answer: "manger"
  },
  {
    question: "Quel est le féminin de 'acteur'?",
    options: ["acteuse", "actrice", "acteur", "acteure"],
    answer: "actrice"
  },
  {
    question: "Quel mot complète correctement: 'Nous ______ au marché.'?",
    options: ["allez", "allons", "va", "vais"],
    answer: "allons"
  },
  {
    question: "Comment dit-on 'Good evening' en français?",
    options: ["Bonjour", "Bonsoir", "Bonne nuit", "Salut"],
    answer: "Bonsoir"
  },
  {
    question: "Lequel de ces mots est un pronom personnel sujet?",
    options: ["le", "moi", "tu", "ton"],
    answer: "tu"
  },
  {
    question: "Quel est le contraire de 'grand'?",
    options: ["petit", "gros", "fort", "haut"],
    answer: "petit"
  },
  {
    question: "Quelle est la bonne traduction de 'My name is Paul'?",
    options: ["Je suis Paul", "Moi c'est Paul", "Je m'appelle Paul", "Il s'appelle Paul"],
    answer: "Je m'appelle Paul"
  },
  {
    question: "Quel est le pluriel de 'le journal'?",
    options: ["les journaux", "les journal", "les journeaux", "les journales"],
    answer: "les journaux"
  },
  {
    question: "Complétez la phrase: 'Marie et Sophie ______ des pommes.'",
    options: ["mange", "mangent", "manges", "mangeons"],
    answer: "mangent"
  },
  {
    question: "Comment dit-on 'Thank you very much' en français?",
    options: ["Merci bien", "Merci beaucoup", "De rien", "S'il te plaît"],
    answer: "Merci beaucoup"
  },
  {
    question: "Quel verbe signifie 'to go'?",
    options: ["venir", "aller", "voir", "avoir"],
    answer: "aller"
  },
  {
    question: "Complétez: 'Nous avons ______ stylos.'",
    options: ["de", "des", "du", "le"],
    answer: "des"
  },
  {
    question: "Comment s'appelle la couleur du ciel?",
    options: ["vert", "rouge", "bleu", "jaune"],
    answer: "bleu"
  },
  {
    question: "Comment dit-on 'school bag'?",
    options: ["le cahier", "le crayon", "le sac d’école", "la règle"],
    answer: "le sac d’école"
  },
  {
    question: "Quel mot est un nom commun?",
    options: ["chien", "joli", "vite", "je"],
    answer: "chien"
  },
  {
    question: "Comment dit-on 'Where is the toilet?'",
    options: ["Où est la toilette ?", "Comment est la toilette ?", "Qui est à la toilette ?", "Où vont les toilettes ?"],
    answer: "Où est la toilette ?"
  },
  {
    question: "Quel temps est utilisé dans la phrase 'Je suis allé au marché'?",
    options: ["présent", "imparfait", "passé composé", "futur"],
    answer: "passé composé"
  },
  {
    question: "Quel est l'article défini pour 'école'?",
    options: ["le", "la", "l’", "les"],
    answer: "l’"
  },
  {
    question: "Le mot 'intelligent' est:",
    options: ["un nom", "un verbe", "un adjectif", "un adverbe"],
    answer: "un adjectif"
  },
  {
    question: "Quel est le féminin de 'français'?",
    options: ["française", "franca", "francaise", "francoise"],
    answer: "française"
  },
  {
    question: "Quel est le verbe conjugué dans: 'Tu fais tes devoirs'?",
    options: ["faire", "fais", "fait", "faites"],
    answer: "fais"
  },
  {
    question: "Quelle est la bonne négation: 'Je mange'?",
    options: ["Je ne mange pas", "Je mange pas", "Je pas mange", "Ne je mange pas"],
    answer: "Je ne mange pas"
  },
  {
    question: "Quel est le mot opposé de 'chaud'?",
    options: ["brûlant", "froid", "tiède", "humide"],
    answer: "froid"
  },
  {
    question: "Complétez la salutation: 'Comment _____-tu?'",
    options: ["es", "vas", "allez", "vas-tu"],
    answer: "vas"
  },
  {
    question: "Lequel de ces mots est un adjectif possessif?",
    options: ["mon", "mais", "moi", "maison"],
    answer: "mon"
  },
  {
    question: "Quel est l’adverbe dans la phrase 'Il court vite'?",
    options: ["Il", "court", "vite", "court vite"],
    answer: "vite"
  },
  {
    question: "Comment s'appelle le repas du matin?",
    options: ["le déjeuner", "le dîner", "le souper", "le petit déjeuner"],
    answer: "le petit déjeuner"
  },
  {
    question: "Quelle phrase est au futur?",
    options: ["Je vais manger", "Je mange", "J'ai mangé", "Je mangeais"],
    answer: "Je vais manger"
  },
  {
    question: "Comment dit-on 'window'?",
    options: ["porte", "fenêtre", "chaise", "lit"],
    answer: "fenêtre"
  },
  {
    question: "Quel est le pluriel de 'cheval'?",
    options: ["chevals", "chevaux", "chevales", "cheveaux"],
    answer: "chevaux"
  },
  {
    question: "Quelle phrase est correcte?",
    options: ["Je suis content", "Je es content", "Tu est content", "Il es content"],
    answer: "Je suis content"
  },
  {
    question: "Quel mot est un pronom relatif?",
    options: ["qui", "que", "dont", "tous les trois"],
    answer: "tous les trois"
  },
  {
    question: "Quelle est la forme correcte du verbe 'avoir' pour 'vous'?",
    options: ["avez", "avons", "ai", "as"],
    answer: "avez"
  },
  {
    question: "Comment dit-on 'teacher'?",
    options: ["élève", "maître", "institutrice", "professeur"],
    answer: "professeur"
  },
  {
    question: "Quel est l'antonyme de 'sale'?",
    options: ["propre", "beau", "petit", "clair"],
    answer: "propre"
  },
  {
    question: "Quel mot n’est pas un fruit?",
    options: ["banane", "orange", "pomme", "pain"],
    answer: "pain"
  },
  {
    question: "Que veut dire 'au revoir'?",
    options: ["bonjour", "salut", "merci", "goodbye"],
    answer: "goodbye"
  },
  {
    question: "Quel mot correspond à 'Monday'?",
    options: ["dimanche", "lundi", "mardi", "jeudi"],
    answer: "lundi"
  },
  {
    question: "Complétez: 'Nous ______ une chanson.'",
    options: ["chanter", "chantons", "chantez", "chantaient"],
    answer: "chantons"
  },
  {
    question: "Quelle forme du verbe est au passé?",
    options: ["je mange", "je mangerai", "j’ai mangé", "je mangeais"],
    answer: "j’ai mangé"
  },
  {
    question: "Quelle phrase est une question?",
    options: ["Tu vas bien?", "Tu vas bien.", "Je vais bien", "Il va bien"],
    answer: "Tu vas bien?"
  },
  {
    question: "Quel est le bon ordre: 'ma – est – bleue – robe'?",
    options: ["Est ma robe bleue", "Ma robe est bleue", "Bleue est ma robe", "Robe est ma bleue"],
    answer: "Ma robe est bleue"
  },
  {
    question: "Comment dit-on 'book'?",
    options: ["livre", "stylo", "chaise", "école"],
    answer: "livre"
  },
  {
    question: "Quel est le pluriel de 'nez'?",
    options: ["nezs", "nez", "nés", "neus"],
    answer: "nez"
  },
  {
    question: "Quel est le contraire de 'noir'?",
    options: ["sombre", "gris", "blanc", "bleu"],
    answer: "blanc"
  },
  {
    question: "Quelle est la bonne réponse: 'Tu t'appelles comment?'",
    options: ["J’ai dix ans", "Je m’appelle Paul", "Il s’appelle Jean", "Comment tu es?"],
    answer: "Je m’appelle Paul"
  },
  {
    question: "Complétez: 'Elle ______ une robe rouge.'",
    options: ["porte", "porter", "portes", "portent"],
    answer: "porte"
  },
  {
    question: "Quel pronom remplace 'la voiture'?",
    options: ["le", "la", "lui", "les"],
    answer: "la"
  },
  {
    question: "Comment s'appelle la mère de ton père?",
    options: ["tante", "grand-mère", "cousine", "maman"],
    answer: "grand-mère"
  },
  {
    question: "Quel est le féminin de 'lion'?",
    options: ["lionne", "lione", "lionette", "lionesse"],
    answer: "lionne"
  },
  {
    question: "Quel est le bon adjectif: 'une voiture _____' (rouge)?",
    options: ["rouges", "rouge", "rouger", "rougée"],
    answer: "rouge"
  },
  {
    question: "Quel verbe complète la phrase: 'Ils _____ du football'?",
    options: ["jouent", "joue", "jouer", "jouait"],
    answer: "jouent"
  },
  {
    question: "Quelle est la bonne traduction de 'I am happy'?",
    options: ["Je suis content", "Je vais heureux", "J’ai content", "Je être heureux"],
    answer: "Je suis content"
  },
  {
    question: "Quel mot est un objet de la classe?",
    options: ["table", "marché", "arbre", "fenêtre"],
    answer: "table"
  },
  {
    question: "Comment dit-on 'to write' en français?",
    options: ["écrire", "lire", "dire", "écouter"],
    answer: "écrire"
  },
  {
    question: "Quelle est la terminaison du verbe 'finir' pour 'nous' au présent?",
    options: ["-ons", "-issons", "-ons", "-ez"],
    answer: "-issons"
  },
  {
    question: "Quelle est la question correcte: '____ tu viens à l’école ?'",
    options: ["Quand", "Pourquoi", "Comment", "Où"],
    answer: "Quand"
  },
  {
    question: "Quel est le passé composé de 'nous mangeons'?",
    options: ["Nous avons mangé", "Nous mangions", "Nous mange", "Nous avons mangez"],
    answer: "Nous avons mangé"
  },
  {
    question: "Quel est le pluriel de 'animal'?",
    options: ["animales", "animaux", "animals", "animos"],
    answer: "animaux"
  },
  {
    question: "Quel est le genre de 'maison'?",
    options: ["masculin", "féminin", "neutre", "pluriel"],
    answer: "féminin"
  },
  {
    question: "Quelle est la bonne phrase?",
    options: ["Je parlé français", "Je parle français", "Je parles français", "Je parlez français"],
    answer: "Je parle français"
  },
  {
    question: "Que veut dire 'S’il vous plaît'?",
    options: ["Excuse me", "Please", "You're welcome", "Good night"],
    answer: "Please"
  },
  {
    question: "Quel est l’adjectif possessif pour 'je'?",
    options: ["ma", "ta", "sa", "leur"],
    answer: "ma"
  },
  {
    question: "Comment dit-on 'pencil' en français?",
    options: ["le stylo", "le crayon", "le cahier", "le sac"],
    answer: "le crayon"
  },
  {
    question: "Quelle expression utilise-t-on pour saluer le matin?",
    options: ["Bonsoir", "Bonne nuit", "Bonjour", "Salut"],
    answer: "Bonjour"
  },
  {
    question: "Quel est le bon verbe pour cette phrase: 'Je _____ du pain'?",
    options: ["mange", "mangent", "manges", "manger"],
    answer: "mange"
  },
  {
    question: "Quelle est la bonne réponse: 'Tu as quel âge ?'",
    options: ["J’ai dix ans", "Je suis dix", "J’ai dixième", "Je dix ans"],
    answer: "J’ai dix ans"
  },
  {
    question: "Comment dit-on 'school' en français?",
    options: ["bibliothèque", "école", "maison", "église"],
    answer: "école"
  },
  {
    question: "Quel est le pronom personnel pour 'Paul et moi'?",
    options: ["ils", "vous", "nous", "on"],
    answer: "nous"
  },
  {
    question: "Quelle préposition complète: 'Je vais _____ marché'?",
    options: ["à", "de", "dans", "chez"],
    answer: "au"
  },
  {
    question: "Que signifie 'il pleut'?",
    options: ["It’s sunny", "It’s raining", "It’s windy", "It’s cold"],
    answer: "It’s raining"
  },
  {
    question: "Comment écrit-on le chiffre 20 en français?",
    options: ["vingt", "dix-neuf", "soixante", "quatorze"],
    answer: "vingt"
  },
  {
    question: "Quel mot est un métier?",
    options: ["pompier", "chaise", "stylo", "crayon"],
    answer: "pompier"
  },
  {
    question: "Comment dit-on 'to read' en français?",
    options: ["écrire", "écouter", "regarder", "lire"],
    answer: "lire"
  },
  {
    question: "Quel est l’opposé de 'rapide'?",
    options: ["lent", "chaud", "bruyant", "gros"],
    answer: "lent"
  },
  {
    question: "Comment dit-on 'I have two brothers'?",
    options: ["J’ai deux frères", "Je suis deux frères", "J’ai deux frèreses", "Je ai deux frères"],
    answer: "J’ai deux frères"
  },
  {
    question: "Complétez: 'Nous allons _____ cinéma demain.'",
    options: ["à", "au", "dans", "chez"],
    answer: "au"
  },
  {
    question: "Que signifie 'je suis en retard'?",
    options: ["I’m early", "I’m late", "I’m sick", "I’m ready"],
    answer: "I’m late"
  },
  {
    question: "Quel est l’article défini pour 'ami'?",
    options: ["la", "le", "l’", "les"],
    answer: "l’"
  },
  {
    question: "Quel est le bon mot pour: 'She is a student'?",
    options: ["Elle est une élève", "Elle es élève", "Elle élève", "Elle est élève"],
    answer: "Elle est élève"
  },
  {
    question: "Comment écrit-on le nombre 100 en français?",
    options: ["cent", "cents", "sente", "sont"],
    answer: "cent"
  },
  {
    question: "Quel mot complète: 'Il fait _____ aujourd’hui.' (weather)",
    options: ["chaud", "devoirs", "nuit", "vent"],
    answer: "chaud"
  },
  {
    question: "Quelle est la traduction de 'every day'?",
    options: ["tous les jours", "quelques jours", "chaque semaine", "souvent"],
    answer: "tous les jours"
  },
  {
    question: "Quel mot n’est pas un vêtement?",
    options: ["chemise", "robe", "chaussure", "épicerie"],
    answer: "épicerie"
  },
  {
    question: "Quel est l'opposé de 'jeune'?",
    options: ["grand", "vieux", "petit", "gentil"],
    answer: "vieux"
  },
  {
    question: "Quel est le verbe conjugué: 'Tu _____ ton stylo'?",
    options: ["prends", "prend", "prendre", "prenne"],
    answer: "prends"
  },
  {
    question: "Comment dit-on 'family' en français?",
    options: ["famille", "femme", "frère", "maison"],
    answer: "famille"
  },
  {
    question: "Complétez: 'Ils _____ à l’école à 8h.'",
    options: ["vont", "va", "allez", "allons"],
    answer: "vont"
  },
  {
    question: "Quelle est la bonne réponse: 'Tu parles anglais ?'",
    options: ["Oui, je parle anglais", "Oui, tu parles anglais", "Non, il parle anglais", "Oui, je parles"],
    answer: "Oui, je parle anglais"
  },
  {
    question: "Comment dit-on 'uncle'?",
    options: ["cousin", "oncle", "père", "frère"],
    answer: "oncle"
  },
  {
    question: "Quel est le bon mot pour 'dog'?",
    options: ["chat", "cheval", "chien", "poule"],
    answer: "chien"
  },
  {
    question: "Complétez: 'J’aime ______ chocolat.'",
    options: ["le", "la", "du", "des"],
    answer: "le"
  },
  {
    question: "Quel est le féminin de 'serveur'?",
    options: ["serveuse", "servante", "servière", "servate"],
    answer: "serveuse"
  },
  {
    question: "Que signifie 'Comment tu t’appelles ?'",
    options: ["How old are you?", "What’s your name?", "Where do you live?", "How are you?"],
    answer: "What’s your name?"
  },
  {
    question: "Quel est le bon mot pour 'bread' en français?",
    options: ["pain", "beurre", "fromage", "lait"],
    answer: "pain"
  },
  {
    question: "Comment dit-on 'mother'?",
    options: ["père", "mère", "sœur", "fille"],
    answer: "mère"
  },
  {
    question: "Complétez: 'Nous _____ en France.'",
    options: ["sommes", "êtes", "es", "sont"],
    answer: "sommes"
  },
  {
    question: "Quel verbe est correct: 'Elle _____ son livre.'",
    options: ["lit", "lis", "lire", "lira"],
    answer: "lit"
  },
  {
    question: "Quelle est la bonne question: '_____ tu aimes le chocolat ?'",
    options: ["Est-ce que", "Quand", "Où", "Comment"],
    answer: "Est-ce que"
  },
  {
    question: "Comment dit-on 'to eat' en français?",
    options: ["manger", "boire", "jouer", "parler"],
    answer: "manger"
  },
  {
    question: "Quelle heure est-il quand il est 14h?",
    options: ["2 PM", "4 PM", "12 PM", "10 PM"],
    answer: "2 PM"
  },
  {
    question: "Quel est le pluriel de 'cheval'?",
    options: ["chevals", "chevaux", "chevales", "chevalles"],
    answer: "chevaux"
  },
  {
    question: "Quelle est la traduction de 'library'?",
    options: ["bibliothèque", "librairie", "école", "mairie"],
    answer: "bibliothèque"
  },
  {
    question: "Quel est le bon mot: 'It is cold today'?",
    options: ["Il fait froid aujourd’hui", "Il est froid ce soir", "Il fait chaud aujourd’hui", "Il est frais"],
    answer: "Il fait froid aujourd’hui"
  },
  {
    question: "Quelle est la bonne conjugaison: 'Je _____ à la maison.'",
    options: ["vais", "vas", "va", "allons"],
    answer: "vais"
  },
  {
    question: "Que veut dire 'Je n’ai pas de stylo'?",
    options: ["I don’t have a pen", "I don’t need a pen", "Give me a pen", "I like the pen"],
    answer: "I don’t have a pen"
  },
  {
    question: "Comment dit-on 'My name is Paul'?",
    options: ["Je m’appelle Paul", "Je suis Paul", "Moi est Paul", "Mon nom est Paul"],
    answer: "Je m’appelle Paul"
  },
  {
    question: "Quel est le féminin de 'acteur'?",
    options: ["acteuse", "actrice", "acteure", "actée"],
    answer: "actrice"
  },
  {
    question: "Complétez: 'Marie a une _____ robe.'",
    options: ["belle", "beau", "bel", "belles"],
    answer: "belle"
  },
  {
    question: "Quel est le contraire de 'grand'?",
    options: ["petit", "fort", "vieux", "beau"],
    answer: "petit"
  },
  {
    question: "Comment écrit-on 70 en français?",
    options: ["soixante-dix", "septante", "soixante-vingt", "soix-dix"],
    answer: "soixante-dix"
  },
  {
    question: "Comment dit-on 'to go' en français?",
    options: ["aller", "venir", "avoir", "faire"],
    answer: "aller"
  },
  {
    question: "Que veut dire 'au revoir'?",
    options: ["hello", "goodbye", "please", "thanks"],
    answer: "goodbye"
  },
  {
    question: "Complétez: 'Tu veux _____ eau ?'",
    options: ["de l’", "de la", "du", "des"],
    answer: "de l’"
  },
  {
    question: "Quel est le bon mot: 'We speak French'?",
    options: ["Nous parlons français", "Nous parlons le français", "Nous parler français", "Nous parlons de français"],
    answer: "Nous parlons français"
  },
  {
    question: "Que veut dire 'février'?",
    options: ["February", "April", "Friday", "Fall"],
    answer: "February"
  },
  {
    question: "Quelle est la bonne phrase?",
    options: ["Il a deux chiens", "Il a deux chien", "Il as deux chiens", "Il as deux chien"],
    answer: "Il a deux chiens"
  },
  {
    question: "Quel est le pluriel de 'journal'?",
    options: ["journals", "journales", "journaux", "journeaux"],
    answer: "journaux"
  },
  {
    question: "Complétez: 'Elle _____ parler espagnol.'",
    options: ["sait", "peut", "doit", "est"],
    answer: "sait"
  },
  {
    question: "Quel mot est une couleur?",
    options: ["rouge", "robe", "école", "vent"],
    answer: "rouge"
  },
  {
    question: "Comment dit-on 'a book' en français?",
    options: ["un livre", "une livre", "le livre", "des livres"],
    answer: "un livre"
  },
  {
    question: "Quel est le bon pronom: 'Marie et Julie' = _____",
    options: ["elles", "ils", "vous", "nous"],
    answer: "elles"
  },
  {
    question: "Comment dit-on 'I live in Ghana'?",
    options: ["J’habite au Ghana", "Je vis Ghana", "J’habite en Ghana", "Je suis à Ghana"],
    answer: "J’habite au Ghana"
  },
  {
    question: "Complétez: 'Mon frère est _____.' (tall)",
    options: ["grand", "grande", "gros", "haut"],
    answer: "grand"
  },
  {
    question: "Quel mot n’est pas un fruit?",
    options: ["pomme", "poire", "chocolat", "banane"],
    answer: "chocolat"
  },
  {
    question: "Que veut dire 'Il est midi'?",
    options: ["It is midnight", "It is noon", "It is morning", "It is evening"],
    answer: "It is noon"
  },
  {
    question: "Quel est le bon verbe: 'Vous _____ un gâteau'?",
    options: ["faites", "fait", "fais", "faisons"],
    answer: "faites"
  },
  {
    question: "Quelle est la bonne réponse: 'Merci'?",
    options: ["De rien", "Bonjour", "Pardon", "Bonsoir"],
    answer: "De rien"
  },
  {
    question: "Que veut dire 'je suis fatigué'?",
    options: ["I’m tired", "I’m sick", "I’m fine", "I’m late"],
    answer: "I’m tired"
  },
  {
    question: "Quel est le féminin de 'cousin'?",
    options: ["cousine", "cousinne", "cousette", "cousone"],
    answer: "cousine"
  },
  {
    question: "Quel est l’adjectif: 'une _____ maison' (white)?",
    options: ["blanche", "blanc", "blanches", "blancs"],
    answer: "blanche"
  },
  {
    question: "Comment dit-on 'teacher' en français?",
    options: ["professeur", "docteur", "vendeur", "serveur"],
    answer: "professeur"
  },
  {
    question: "Quelle est la bonne conjugaison: 'Ils _____ une chanson'?",
    options: ["chantent", "chante", "chantes", "chantons"],
    answer: "chantent"
  },
  {
    question: "Que veut dire 'je suis désolé'?",
    options: ["I’m sorry", "I’m happy", "I’m late", "I’m here"],
    answer: "I’m sorry"
  },
  {
    question: "Quel est le contraire de 'facile'?",
    options: ["difficile", "rapide", "lent", "simple"],
    answer: "difficile"
  },
  {
    question: "Comment dit-on 'my house'?",
    options: ["ma maison", "mon maison", "mes maison", "moi maison"],
    answer: "ma maison"
  },
  {
    question: "Complétez: 'Tu _____ à l’école à 8h?'",
    options: ["vas", "va", "allez", "vais"],
    answer: "vas"
  },
  {
    question: "Quel est le bon article: _____ école est grande.",
    options: ["L’", "La", "Le", "Les"],
    answer: "L’"
  },
  {
    question: "Quelle est la bonne question: '____ tu habites à Accra ?'",
    options: ["Est-ce que", "Quand", "Combien", "Pourquoi"],
    answer: "Est-ce que"
  },
  {
    question: "Comment dit-on 'sister'?",
    options: ["sœur", "fille", "mère", "tante"],
    answer: "sœur"
  },
  {
    question: "Quel est l’adjectif possessif pour 'vous'?",
    options: ["votre", "notre", "leur", "mon"],
    answer: "votre"
  },
  {
    question: "Comment dit-on 'Where are you going?' en français?",
    options: ["Où vas-tu ?", "Comment vas-tu ?", "Quand vas-tu ?", "Pourquoi vas-tu ?"],
    answer: "Où vas-tu ?"
  },
  {
    question: "Quel est le verbe correct: 'Ils _____ une pizza.'",
    options: ["mangent", "mange", "manges", "mangeons"],
    answer: "mangent"
  },
  {
    question: "Que signifie 'chat'?",
    options: ["cat", "dog", "fish", "cow"],
    answer: "cat"
  },
  {
    question: "Comment dit-on 'window' en français?",
    options: ["fenêtre", "porte", "chaise", "table"],
    answer: "fenêtre"
  },
  {
    question: "Quelle est la bonne phrase?",
    options: ["Nous avons trois enfants", "Nous avons trois enfant", "Nous a trois enfants", "Nous avons enfant"],
    answer: "Nous avons trois enfants"
  },
  {
    question: "Quel est le féminin de 'heureux'?",
    options: ["heureuse", "heureus", "heureuses", "heureuxse"],
    answer: "heureuse"
  },
  {
    question: "Comment dit-on 'She is a nurse'?",
    options: ["Elle est infirmière", "Il est infirmière", "Elle est docteur", "Elle est médecine"],
    answer: "Elle est infirmière"
  },
  {
    question: "Quel est le contraire de 'chaud'?",
    options: ["froid", "lent", "rapide", "court"],
    answer: "froid"
  },
  {
    question: "Comment dit-on 'I play football'?",
    options: ["Je joue au football", "Je fais football", "Je prend football", "Je suis football"],
    answer: "Je joue au football"
  },
  {
    question: "Quelle est la forme correcte: 'Il _____ fatigué.'",
    options: ["est", "es", "suis", "être"],
    answer: "est"
  },
  {
    question: "Que veut dire 'demain'?",
    options: ["tomorrow", "today", "yesterday", "now"],
    answer: "tomorrow"
  },
  {
    question: "Quel est le bon pronom: 'Moi et toi'?",
    options: ["nous", "vous", "ils", "eux"],
    answer: "nous"
  },
  {
    question: "Comment dit-on 'green' en français?",
    options: ["vert", "gris", "bleu", "noir"],
    answer: "vert"
  },
  {
    question: "Quel mot est un métier?",
    options: ["boulanger", "stylo", "maison", "rouge"],
    answer: "boulanger"
  },
  {
    question: "Complétez: 'Il y a _____ pommes sur la table.'",
    options: ["des", "de", "du", "la"],
    answer: "des"
  },
  {
    question: "Quel est le pluriel de 'animal'?",
    options: ["animaux", "animales", "animals", "animalles"],
    answer: "animaux"
  },
  {
    question: "Comment dit-on 'I am going to the market'?",
    options: ["Je vais au marché", "Je suis au marché", "Je fais le marché", "Je prends le marché"],
    answer: "Je vais au marché"
  },
  {
    question: "Que veut dire 'Il neige'?",
    options: ["It is snowing", "It is raining", "It is windy", "It is sunny"],
    answer: "It is snowing"
  },
  {
    question: "Quelle est la bonne réponse: 'Comment tu t’appelles ?'",
    options: ["Je m’appelle Paul", "Je suis bien", "J’ai douze ans", "Tu t’appelles comment"],
    answer: "Je m’appelle Paul"
  },
  {
    question: "Comment dit-on 'Monday'?",
    options: ["lundi", "dimanche", "vendredi", "jeudi"],
    answer: "lundi"
  },
  {
    question: "Quel est le bon possessif: '_____ frère est gentil.' (my)",
    options: ["Mon", "Ma", "Mes", "Le"],
    answer: "Mon"
  },
  {
    question: "Quel mot est une boisson?",
    options: ["jus", "pain", "table", "lait"],
    answer: "jus"
  },
  {
    question: "Complétez: 'Nous _____ un film.'",
    options: ["regardons", "regarde", "regardes", "regarder"],
    answer: "regardons"
  },
  {
    question: "Quelle est la bonne question: '____ est ton anniversaire ?'",
    options: ["Quand", "Pourquoi", "Où", "Comment"],
    answer: "Quand"
  },
  {
    question: "Que veut dire 'Je suis en retard'?",
    options: ["I am late", "I am early", "I am sick", "I am fast"],
    answer: "I am late"
  },
  {
    question: "Quel est le bon verbe: 'Elle _____ la porte.'",
    options: ["ouvre", "ouvert", "ouvrement", "ouvers"],
    answer: "ouvre"
  },
  {
    question: "Quel est le mot pour 'kitchen'?",
    options: ["cuisine", "salon", "toilette", "chambre"],
    answer: "cuisine"
  },
  {
    question: "Quel est le pluriel de 'nez'?",
    options: ["nez", "nes", "nezs", "ne"],
    answer: "nez"
  },
  {
    question: "Comment dit-on 'the students'?",
    options: ["les élèves", "les écoliers", "les écoles", "les enseignements"],
    answer: "les élèves"
  },
  {
    question: "Complétez: 'Est-ce que tu _____ des frères ?'",
    options: ["as", "a", "es", "ai"],
    answer: "as"
  },
  {
    question: "Quel est le bon mot: 'big city'?",
    options: ["grande ville", "ville grande", "gros ville", "village grande"],
    answer: "grande ville"
  },
  {
    question: "Que veut dire 'beaucoup'?",
    options: ["a lot", "a few", "nothing", "some"],
    answer: "a lot"
  },
  {
    question: "Quel est le féminin de 'lion'?",
    options: ["lionne", "lionette", "lionesse", "lionesse"],
    answer: "lionne"
  },
  {
    question: "Quel est le contraire de 'jeune'?",
    options: ["vieux", "petit", "rapide", "blond"],
    answer: "vieux"
  },
  {
    question: "Comment dit-on 'I am thirsty'?",
    options: ["J’ai soif", "Je suis soif", "Je soif", "Je ai soif"],
    answer: "J’ai soif"
  },
  {
    question: "Complétez: 'Tu _____ bien aujourd’hui.'",
    options: ["travailles", "travaille", "travailler", "travaillons"],
    answer: "travailles"
  },
  {
    question: "Que veut dire 'chaise'?",
    options: ["chair", "desk", "table", "couch"],
    answer: "chair"
  },
  {
    question: "Quel mot est un jour de la semaine?",
    options: ["mardi", "mars", "matin", "midi"],
    answer: "mardi"
  },
  {
    question: "Quel est le bon article pour 'ordinateur'?",
    options: ["un", "une", "le", "la"],
    answer: "un"
  },
  {
    question: "Comment dit-on 'good night'?",
    options: ["bonne nuit", "bonsoir", "bonjour", "salut"],
    answer: "bonne nuit"
  },
  {
    question: "Quel mot est un adjectif?",
    options: ["intelligent", "vite", "beaucoup", "vite"],
    answer: "intelligent"
  },
  {
    question: "Que veut dire 'tristesse'?",
    options: ["sadness", "happiness", "fear", "love"],
    answer: "sadness"
  },
  {
    question: "Complétez: 'Ils _____ au football tous les dimanches.'",
    options: ["jouent", "joue", "jouer", "jouons"],
    answer: "jouent"
  },
  {
    question: "Quel est le bon verbe: 'Je _____ un livre.'",
    options: ["lis", "lit", "lire", "lisez"],
    answer: "lis"
  },
  {
    question: "Comment dit-on 'a dress'?",
    options: ["une robe", "un pantalon", "une jupe", "un costume"],
    answer: "une robe"
  },
  {
    question: "Que veut dire 'Il fait beau'?",
    options: ["The weather is nice", "He is beautiful", "It is late", "It is cold"],
    answer: "The weather is nice"
  },
  {
    question: "Complétez: 'Ma sœur _____ en Espagne.'",
    options: ["habite", "habites", "habitent", "habiter"],
    answer: "habite"
  },
  {
    question: "Que signifie 'bibliothèque'?",
    options: ["library", "book", "school", "shop"],
    answer: "library"
  },
  {
    question: "Complétez: 'Je _____ mon petit déjeuner.'",
    options: ["prends", "prend", "prendre", "prenez"],
    answer: "prends"
  },
  {
    question: "Comment dit-on 'She is very intelligent'?",
    options: ["Elle est très intelligente", "Il est très intelligente", "Elle est beaucoup intelligente", "Elle est très intelligent"],
    answer: "Elle est très intelligente"
  },
  {
    question: "Quel est le pluriel de 'cheval'?",
    options: ["chevaux", "chevals", "chevaus", "chevals"],
    answer: "chevaux"
  },
  {
    question: "Que veut dire 'pantalon'?",
    options: ["trousers", "shirt", "hat", "jacket"],
    answer: "trousers"
  },
  {
    question: "Complétez: 'Vous _____ à la maison.'",
    options: ["êtes", "sommes", "sont", "es"],
    answer: "êtes"
  },
  {
    question: "Quel mot n’est pas une couleur?",
    options: ["chien", "bleu", "noir", "rouge"],
    answer: "chien"
  },
  {
    question: "Quel est le féminin de 'acteur'?",
    options: ["actrice", "acteuse", "acteure", "actreur"],
    answer: "actrice"
  },
  {
    question: "Que veut dire 'heure'?",
    options: ["hour", "day", "month", "year"],
    answer: "hour"
  },
  {
    question: "Complétez: 'Elles _____ en retard.'",
    options: ["sont", "est", "sommes", "es"],
    answer: "sont"
  },
  {
    question: "Comment dit-on 'bicycle' en français?",
    options: ["vélo", "voiture", "camion", "moto"],
    answer: "vélo"
  },
  {
    question: "Quel est le bon article pour 'avion'?",
    options: ["un", "une", "la", "les"],
    answer: "un"
  },
  {
    question: "Que veut dire 'Il fait froid'?",
    options: ["It is cold", "It is hot", "It is sunny", "It is windy"],
    answer: "It is cold"
  },
  {
    question: "Complétez: 'Nous _____ aller à l’école.'",
    options: ["devons", "doivent", "dois", "devez"],
    answer: "devons"
  },
  {
    question: "Que signifie 'hôpital'?",
    options: ["hospital", "hotel", "home", "house"],
    answer: "hospital"
  },
  {
    question: "Comment dit-on 'I like oranges'?",
    options: ["J’aime les oranges", "Je mange les oranges", "Je suis orange", "J’ai des oranges"],
    answer: "J’aime les oranges"
  },
  {
    question: "Quel mot est une boisson?",
    options: ["eau", "pain", "pomme", "chaise"],
    answer: "eau"
  },
  {
    question: "Complétez: 'Il _____ son devoir.'",
    options: ["fait", "faire", "fais", "faisez"],
    answer: "fait"
  },
  {
    question: "Que veut dire 'toujours'?",
    options: ["always", "sometimes", "never", "early"],
    answer: "always"
  },
  {
    question: "Comment dit-on 'good morning'?",
    options: ["bonjour", "bonsoir", "bonne nuit", "salut"],
    answer: "bonjour"
  },
  {
    question: "Complétez: 'Nous _____ au cinéma samedi.'",
    options: ["allons", "allez", "vas", "va"],
    answer: "allons"
  },
  {
    question: "Quel est le bon pronom pour 'Marie et toi'?",
    options: ["vous", "nous", "elles", "ils"],
    answer: "vous"
  },
  {
    question: "Que signifie 'marché'?",
    options: ["market", "march", "walk", "car"],
    answer: "market"
  },
  {
    question: "Comment dit-on 'my teacher'?",
    options: ["mon professeur", "ma enseignante", "le professeur moi", "ma professeuse"],
    answer: "mon professeur"
  },
  {
    question: "Complétez: 'Je ne _____ pas.'",
    options: ["sais", "sait", "savez", "savons"],
    answer: "sais"
  },
  {
    question: "Que veut dire 'manger'?",
    options: ["to eat", "to cook", "to drink", "to read"],
    answer: "to eat"
  },
  {
    question: "Quel est le bon mot pour 'beautiful'?",
    options: ["beau", "laid", "petit", "grand"],
    answer: "beau"
  },
  {
    question: "Complétez: 'Marie _____ du piano.'",
    options: ["joue", "jouent", "joues", "jouons"],
    answer: "joue"
  },
  {
    question: "Que signifie 'voiture'?",
    options: ["car", "train", "bicycle", "motorcycle"],
    answer: "car"
  },
  {
    question: "Comment dit-on 'I don't understand'?",
    options: ["Je ne comprends pas", "Je ne parle pas", "Je suis perdu", "Je suis fatigué"],
    answer: "Je ne comprends pas"
  },
  {
    question: "Quel est le féminin de 'ami'?",
    options: ["amie", "amienne", "amié", "amis"],
    answer: "amie"
  },
  {
    question: "Complétez: 'Vous _____ français ?'",
    options: ["parlez", "parle", "parlons", "parles"],
    answer: "parlez"
  },
  {
    question: "Que veut dire 'maison'?",
    options: ["house", "mouse", "mission", "mansion"],
    answer: "house"
  },
  {
    question: "Comment dit-on 'see you tomorrow'?",
    options: ["à demain", "aujourd’hui", "à bientôt", "ce soir"],
    answer: "à demain"
  },
  {
    question: "Quel mot est un vêtement?",
    options: ["chemise", "pain", "chaise", "route"],
    answer: "chemise"
  },
  {
    question: "Que signifie 'rapide'?",
    options: ["fast", "slow", "tall", "short"],
    answer: "fast"
  },
  {
    question: "Complétez: 'Tu _____ à l’école tous les jours.'",
    options: ["vas", "va", "allez", "allons"],
    answer: "vas"
  },
  {
    question: "Quel est le bon mot pour 'weather'?",
    options: ["temps", "météo", "climat", "pluie"],
    answer: "météo"
  },
  {
    question: "Que veut dire 'livre'?",
    options: ["book", "library", "pen", "paper"],
    answer: "book"
  },
  {
    question: "Complétez: 'Nous _____ à 8 heures.'",
    options: ["commençons", "commence", "commences", "commencent"],
    answer: "commençons"
  },
  {
    question: "Que signifie 'stylo'?",
    options: ["pen", "pencil", "book", "paper"],
    answer: "pen"
  },
  {
    question: "Quel est le bon verbe: 'Ils _____ leurs devoirs.'",
    options: ["font", "fait", "fais", "faisent"],
    answer: "font"
  },
  {
    question: "Comment dit-on 'my friend is tall'?",
    options: ["Mon ami est grand", "Mon ami est petit", "Mon ami est rapide", "Mon ami est gros"],
    answer: "Mon ami est grand"
  },
  {
    question: "Que veut dire 'parfois'?",
    options: ["sometimes", "never", "often", "rarely"],
    answer: "sometimes"
  },
  {
    question: "Complétez: 'Elle _____ son livre.'",
    options: ["lit", "lis", "lire", "lisez"],
    answer: "lit"
  },
  {
    question: "Comment dit-on 'breakfast'?",
    options: ["petit déjeuner", "dîner", "déjeuner", "souper"],
    answer: "petit déjeuner"
  },
  {
    question: "Quel est le contraire de 'sale'?",
    options: ["propre", "poussiéreux", "mouillé", "sombre"],
    answer: "propre"
  },
  {
    question: "Complétez: 'Tu _____ bien le français.'",
    options: ["parles", "parle", "parlons", "parlez"],
    answer: "parles"
  },
  {
    question: "Que signifie 'chaussure'?",
    options: ["shoe", "shirt", "chair", "house"],
    answer: "shoe"
  },
  {
    question: "Complétez: 'Nous _____ au parc le dimanche.'",
    options: ["allons", "allez", "vas", "va"],
    answer: "allons"
  },
  {
    question: "Quel est le pluriel de 'animal'?",
    options: ["animaux", "animals", "animales", "animau"],
    answer: "animaux"
  },
  {
    question: "Comment dit-on 'Monday' en français?",
    options: ["lundi", "mardi", "dimanche", "jeudi"],
    answer: "lundi"
  },
  {
    question: "Quel est le féminin de 'acteur'?",
    options: ["actrice", "acteure", "acteur", "acteuse"],
    answer: "actrice"
  },
  {
    question: "Complétez: 'Les élèves _____ à l’école.'",
    options: ["vont", "va", "allez", "allons"],
    answer: "vont"
  },
  {
    question: "Comment dit-on 'window' en français?",
    options: ["fenêtre", "porte", "mur", "plafond"],
    answer: "fenêtre"
  },
  {
    question: "Que veut dire 'chat'?",
    options: ["cat", "dog", "bird", "rat"],
    answer: "cat"
  },
  {
    question: "Complétez: 'Il _____ une belle voiture.'",
    options: ["a", "as", "ai", "ont"],
    answer: "a"
  },
  {
    question: "Comment dit-on 'a glass of water'?",
    options: ["un verre d’eau", "un bol de lait", "une tasse de thé", "un litre de jus"],
    answer: "un verre d’eau"
  },
  {
    question: "Quel est le contraire de 'chaud'?",
    options: ["froid", "lent", "fort", "rapide"],
    answer: "froid"
  },
  {
    question: "Complétez: 'Marie et Anne _____ contentes.'",
    options: ["sont", "est", "es", "sommes"],
    answer: "sont"
  },
  {
    question: "Que signifie 'école'?",
    options: ["school", "church", "bank", "market"],
    answer: "school"
  },
  {
    question: "Comment dit-on 'We are ready'?",
    options: ["Nous sommes prêts", "Nous avons prêt", "Nous sommes prêt", "Nous allons prêt"],
    answer: "Nous sommes prêts"
  },
  {
    question: "Que veut dire 'couteau'?",
    options: ["knife", "cup", "spoon", "fork"],
    answer: "knife"
  },
  {
    question: "Complétez: 'Tu _____ faim?'",
    options: ["as", "a", "ai", "avez"],
    answer: "as"
  },
  {
    question: "Comment dit-on 'teacher' en français?",
    options: ["professeur", "directeur", "élève", "docteur"],
    answer: "professeur"
  },
  {
    question: "Quel mot signifie 'evening'?",
    options: ["soir", "matin", "nuit", "jour"],
    answer: "soir"
  },
  {
    question: "Complétez: 'Ils _____ la télévision.'",
    options: ["regardent", "regarde", "regardons", "regardes"],
    answer: "regardent"
  },
  {
    question: "Que veut dire 'vérité'?",
    options: ["truth", "lie", "story", "idea"],
    answer: "truth"
  },
  {
    question: "Comment dit-on 'I am tired'?",
    options: ["Je suis fatigué", "J’ai faim", "Je suis en retard", "Je suis rapide"],
    answer: "Je suis fatigué"
  },
  {
    question: "Quel est le contraire de 'petit'?",
    options: ["grand", "gros", "court", "long"],
    answer: "grand"
  },
  {
    question: "Complétez: 'Nous _____ une chanson.'",
    options: ["chantons", "chantez", "chantes", "chantent"],
    answer: "chantons"
  },
  {
    question: "Que signifie 'chaise'?",
    options: ["chair", "table", "bed", "lamp"],
    answer: "chair"
  },
  {
    question: "Comment dit-on 'green' en français?",
    options: ["vert", "bleu", "gris", "rouge"],
    answer: "vert"
  },
  {
    question: "Quel est le féminin de 'lion'?",
    options: ["lionne", "lionesse", "lione", "lionna"],
    answer: "lionne"
  },
  {
    question: "Complétez: 'Je _____ un sandwich.'",
    options: ["mange", "manges", "mangent", "manger"],
    answer: "mange"
  },
  {
    question: "Que veut dire 'montagne'?",
    options: ["mountain", "valley", "forest", "hill"],
    answer: "mountain"
  },
  {
    question: "Comment dit-on 'a red car'?",
    options: ["une voiture rouge", "un rouge voiture", "une rouge voiture", "un voiture rouge"],
    answer: "une voiture rouge"
  },
  {
    question: "Que signifie 'chien'?",
    options: ["dog", "cat", "goat", "cow"],
    answer: "dog"
  },
  {
    question: "Complétez: 'Elle _____ un roman.'",
    options: ["lit", "lis", "lire", "lisons"],
    answer: "lit"
  },
  {
    question: "Comment dit-on 'pen' en français?",
    options: ["stylo", "crayon", "livre", "papier"],
    answer: "stylo"
  },
  {
    question: "Quel est le pluriel de 'journal'?",
    options: ["journaux", "journales", "journales", "journas"],
    answer: "journaux"
  },
  {
    question: "Complétez: 'Ils _____ en vacances.'",
    options: ["sont", "sommes", "êtes", "es"],
    answer: "sont"
  },
  {
    question: "Que signifie 'chambre'?",
    options: ["room", "bed", "shelf", "curtain"],
    answer: "room"
  },
  {
    question: "Comment dit-on 'What is your name?'",
    options: ["Comment tu t’appelles ?", "Quel est ton âge ?", "Comment ça va ?", "Où vas-tu ?"],
    answer: "Comment tu t’appelles ?"
  },
  {
    question: "Complétez: 'Vous _____ votre repas.'",
    options: ["mangez", "mangent", "manges", "mange"],
    answer: "mangez"
  },
  {
    question: "Que veut dire 'cheveux'?",
    options: ["hair", "head", "face", "ears"],
    answer: "hair"
  },
  {
    question: "Comment dit-on 'Friday' en français?",
    options: ["vendredi", "samedi", "dimanche", "lundi"],
    answer: "vendredi"
  },
  {
    question: "Quel mot est un fruit?",
    options: ["pomme", "poule", "pain", "poisson"],
    answer: "pomme"
  },
  {
    question: "Complétez: 'Je _____ à la bibliothèque.'",
    options: ["vais", "vas", "va", "allons"],
    answer: "vais"
  },
  {
    question: "Que signifie 'lire'?",
    options: ["to read", "to write", "to speak", "to draw"],
    answer: "to read"
  },
  {
    question: "Comment dit-on 'happy'?",
    options: ["heureux", "triste", "fâché", "fatigué"],
    answer: "heureux"
  },
  {
    question: "Complétez: 'Nous _____ un film ce soir.'",
    options: ["regardons", "regardent", "regardes", "regarde"],
    answer: "regardons"
  },
  {
    question: "Que veut dire 'soleil'?",
    options: ["sun", "moon", "star", "sky"],
    answer: "sun"
  },
  {
    question: "Comment dit-on 'mother' en français?",
    options: ["mère", "père", "soeur", "tante"],
    answer: "mère"
  },
  {
    question: "Comment dit-on 'school bag' en français?",
    options: ["cartable", "sac", "sac à dos", "valise"],
    answer: "cartable"
  },
  {
    question: "Que signifie 'bibliothèque'?",
    options: ["library", "bookstore", "school", "lab"],
    answer: "library"
  },
  {
    question: "Complétez: 'Elle _____ ses devoirs chaque soir.'",
    options: ["fait", "fais", "font", "faisons"],
    answer: "fait"
  },
  {
    question: "Quel est le contraire de 'heureux'?",
    options: ["triste", "content", "fatigué", "gentil"],
    answer: "triste"
  },
  {
    question: "Comment dit-on 'a beautiful dress' en français?",
    options: ["une belle robe", "une robe belle", "un beau robe", "un robe belle"],
    answer: "une belle robe"
  },
  {
    question: "Quel est le féminin de 'vendeur'?",
    options: ["vendeuse", "vendeuress", "vendeure", "venda"],
    answer: "vendeuse"
  },
  {
    question: "Complétez: 'Tu _____ le bus chaque matin?'",
    options: ["prends", "prend", "prenons", "prennent"],
    answer: "prends"
  },
  {
    question: "Comment dit-on 'the weather is nice'?",
    options: ["Il fait beau", "Il fait mauvais", "Il neige", "Il pleut"],
    answer: "Il fait beau"
  },
  {
    question: "Que signifie 'clé'?",
    options: ["key", "nail", "screw", "handle"],
    answer: "key"
  },
  {
    question: "Comment dit-on 'doctor' en français?",
    options: ["médecin", "malade", "hôpital", "docteur"],
    answer: "médecin"
  },
  {
    question: "Complétez: 'Les enfants _____ beaucoup.'",
    options: ["jouent", "joue", "joues", "jouons"],
    answer: "jouent"
  },
  {
    question: "Quel est le pluriel de 'cheval'?",
    options: ["chevaux", "chevals", "chevalles", "chevales"],
    answer: "chevaux"
  },
  {
    question: "Que veut dire 'pantalon'?",
    options: ["trousers", "shirt", "hat", "belt"],
    answer: "trousers"
  },
  {
    question: "Comment dit-on 'He is my friend'?",
    options: ["Il est mon ami", "Il est ton ami", "C’est moi", "Il a un ami"],
    answer: "Il est mon ami"
  },
  {
    question: "Complétez: 'Nous _____ une lettre à notre tante.'",
    options: ["écrivons", "écrivent", "écris", "écrit"],
    answer: "écrivons"
  },
  {
    question: "Quel est le contraire de 'noir'?",
    options: ["blanc", "bleu", "rouge", "gris"],
    answer: "blanc"
  },
  {
    question: "Que signifie 'montre'?",
    options: ["watch", "mountain", "cloud", "glove"],
    answer: "watch"
  },
  {
    question: "Comment dit-on 'I speak French'?",
    options: ["Je parle français", "Je parle France", "Je dit français", "Je dis France"],
    answer: "Je parle français"
  },
  {
    question: "Complétez: 'Il _____ froid en hiver.'",
    options: ["fait", "est", "a", "va"],
    answer: "fait"
  },
  {
    question: "Quel mot signifie 'to travel'?",
    options: ["voyager", "travailler", "visiter", "marcher"],
    answer: "voyager"
  },
  {
    question: "Que veut dire 'étoile'?",
    options: ["star", "sky", "sun", "cloud"],
    answer: "star"
  },
  {
    question: "Complétez: 'Ma sœur _____ très intelligente.'",
    options: ["est", "es", "sois", "sont"],
    answer: "est"
  },
  {
    question: "Comment dit-on 'a white shirt' en français?",
    options: ["une chemise blanche", "un chemise blanc", "une blanc chemise", "un blanche chemise"],
    answer: "une chemise blanche"
  },
  {
    question: "Quel est le contraire de 'propre'?",
    options: ["sale", "poli", "gentil", "joli"],
    answer: "sale"
  },
  {
    question: "Que signifie 'chaud'?",
    options: ["hot", "cold", "wet", "clean"],
    answer: "hot"
  },
  {
    question: "Comment dit-on 'to write'?",
    options: ["écrire", "lire", "parler", "marcher"],
    answer: "écrire"
  },
  {
    question: "Complétez: 'Elles _____ en train de lire.'",
    options: ["sont", "est", "es", "sommes"],
    answer: "sont"
  },
  {
    question: "Que veut dire 'rue'?",
    options: ["street", "building", "car", "corner"],
    answer: "street"
  },
  {
    question: "Quel mot correspond à 'bread'?",
    options: ["pain", "fromage", "beurre", "viande"],
    answer: "pain"
  },
  {
    question: "Complétez: 'Vous _____ au marché demain?'",
    options: ["allez", "vas", "va", "allons"],
    answer: "allez"
  },
  {
    question: "Comment dit-on 'my family'?",
    options: ["ma famille", "mon famille", "mes famille", "le famille"],
    answer: "ma famille"
  },
  {
    question: "Que signifie 'voiture'?",
    options: ["car", "train", "plane", "bus"],
    answer: "car"
  },
  {
    question: "Quel est le féminin de 'étudiant'?",
    options: ["étudiante", "étudiante", "étudiantie", "étudianna"],
    answer: "étudiante"
  },
  {
    question: "Complétez: 'Marc _____ une chanson.'",
    options: ["chante", "chantent", "chantons", "chantes"],
    answer: "chante"
  },
  {
    question: "Comment dit-on 'to dance' en français?",
    options: ["danser", "marcher", "chanter", "jouer"],
    answer: "danser"
  },
  {
    question: "Que veut dire 'porte'?",
    options: ["door", "floor", "roof", "wall"],
    answer: "door"
  },
  {
    question: "Complétez: 'Ils _____ leurs livres.'",
    options: ["ouvrent", "ouvre", "ouvrons", "ouvres"],
    answer: "ouvrent"
  },
  {
    question: "Quel mot signifie 'early'?",
    options: ["tôt", "tard", "vite", "longtemps"],
    answer: "tôt"
  },
  {
    question: "Comment dit-on 'She is at home'?",
    options: ["Elle est à la maison", "Elle a maison", "Elle est maison", "Elle maison est"],
    answer: "Elle est à la maison"
  },
  {
    question: "Que signifie 'livre'?",
    options: ["book", "leaf", "pen", "paper"],
    answer: "book"
  },
  {
    question: "Complétez: 'Nous _____ nos amis demain.'",
    options: ["voyons", "vois", "voit", "voyez"],
    answer: "voyons"
  },
  {
    question: "Quel est le pluriel de 'nez'?",
    options: ["nez", "neux", "nezs", "ness"],
    answer: "nez"
  },
  {
    question: "Que veut dire 'pain au chocolat'?",
    options: ["chocolate bread", "chocolate milk", "chocolate cake", "hot chocolate"],
    answer: "chocolate bread"
  },
  {
    question: "Comment dit-on 'They are students'?",
    options: ["Ils sont étudiants", "Ils est étudiants", "Ils sommes étudiants", "Ils être étudiants"],
    answer: "Ils sont étudiants"
  },
  {
    question: "Quel mot correspond à 'garden'?",
    options: ["jardin", "forêt", "champ", "plage"],
    answer: "jardin"
  },
  {
    question: "Complétez: 'Tu _____ ton lit le matin?'",
    options: ["fais", "fait", "font", "faisons"],
    answer: "fais"
  },
  {
    question: "Que veut dire 'chaise'?",
    options: ["chair", "table", "room", "bed"],
    answer: "chair"
  },
  {
    question: "Complétez: 'Les filles _____ dansent bien.'",
    options: ["dansent", "danse", "dansons", "danses"],
    answer: "dansent"
  },
  {
    question: "Comment dit-on 'We eat rice' en français?",
    options: ["Nous mangeons du riz", "Nous mange riz", "On mangé du riz", "Nous mange du riz"],
    answer: "Nous mangeons du riz"
  },
  {
    question: "Quel est le contraire de 'grand'?",
    options: ["petit", "gros", "long", "haut"],
    answer: "petit"
  },
  {
    question: "Que signifie 'école'?",
    options: ["school", "church", "market", "hospital"],
    answer: "school"
  },
  {
    question: "Complétez: 'Il _____ au stade maintenant.'",
    options: ["va", "vas", "allez", "vais"],
    answer: "va"
  },
  {
    question: "Comment dit-on 'good evening'?",
    options: ["bonsoir", "bonjour", "bonne nuit", "salut"],
    answer: "bonsoir"
  },
  {
    question: "Que veut dire 'fenêtre'?",
    options: ["window", "door", "roof", "floor"],
    answer: "window"
  },
  {
    question: "Quel est le féminin de 'acteur'?",
    options: ["actrice", "acteure", "acteuse", "actrielle"],
    answer: "actrice"
  },
  {
    question: "Complétez: 'Vous _____ très gentils.'",
    options: ["êtes", "êtesz", "soyez", "es"],
    answer: "êtes"
  },
  {
    question: "Comment dit-on 'birthday' en français?",
    options: ["anniversaire", "cadeau", "naissance", "fête"],
    answer: "anniversaire"
  },
  {
    question: "Que signifie 'poisson'?",
    options: ["fish", "chicken", "meat", "bread"],
    answer: "fish"
  },
  {
    question: "Complétez: 'Nous _____ nos parents chaque dimanche.'",
    options: ["visitons", "visitez", "visites", "visite"],
    answer: "visitons"
  },
  {
    question: "Quel mot veut dire 'to run'?",
    options: ["courir", "marcher", "sauter", "jouer"],
    answer: "courir"
  },
  {
    question: "Que veut dire 'hôpital'?",
    options: ["hospital", "hotel", "school", "clinic"],
    answer: "hospital"
  },
  {
    question: "Complétez: 'Il _____ un stylo bleu.'",
    options: ["a", "as", "ai", "avons"],
    answer: "a"
  },
  {
    question: "Comment dit-on 'sister' en français?",
    options: ["sœur", "fille", "tante", "mère"],
    answer: "sœur"
  },
  {
    question: "Que signifie 'cheveux'?",
    options: ["hair", "teeth", "nose", "eyes"],
    answer: "hair"
  },
  {
    question: "Complétez: 'Tu _____ bien le français?'",
    options: ["parles", "parle", "parlons", "parlez"],
    answer: "parles"
  },
  {
    question: "Quel est le pluriel de 'journal'?",
    options: ["journaux", "journals", "journales", "journauxs"],
    answer: "journaux"
  },
  {
    question: "Que veut dire 'manger'?",
    options: ["to eat", "to drink", "to sleep", "to run"],
    answer: "to eat"
  },
  {
    question: "Complétez: 'Elles _____ fatiguées après l’école.'",
    options: ["sont", "es", "est", "sommes"],
    answer: "sont"
  },
  {
    question: "Comment dit-on 'teacher' en français?",
    options: ["enseignant", "élève", "directeur", "parent"],
    answer: "enseignant"
  },
  {
    question: "Quel mot correspond à 'fruit'?",
    options: ["pomme", "viande", "pain", "riz"],
    answer: "pomme"
  },
  {
    question: "Complétez: 'Vous _____ vos devoirs maintenant?'",
    options: ["faites", "fais", "fait", "font"],
    answer: "faites"
  },
  {
    question: "Que signifie 'ville'?",
    options: ["city", "village", "house", "street"],
    answer: "city"
  },
  {
    question: "Comment dit-on 'my uncle'?",
    options: ["mon oncle", "ma oncle", "mes oncles", "le oncle"],
    answer: "mon oncle"
  },
  {
    question: "Que veut dire 'fleur'?",
    options: ["flower", "fruit", "leaf", "tree"],
    answer: "flower"
  },
  {
    question: "Complétez: 'Je _____ aller à l’école tôt.'",
    options: ["dois", "doit", "devez", "devons"],
    answer: "dois"
  },
  {
    question: "Quel est le féminin de 'lion'?",
    options: ["lionne", "lionneuse", "lionesse", "lionette"],
    answer: "lionne"
  },
  {
    question: "Comment dit-on 'to sleep'?",
    options: ["dormir", "rester", "manger", "sauter"],
    answer: "dormir"
  },
  {
    question: "Que signifie 'montagne'?",
    options: ["mountain", "valley", "river", "forest"],
    answer: "mountain"
  },
  {
    question: "Complétez: 'Nous _____ souvent en vacances.'",
    options: ["partons", "pars", "part", "partez"],
    answer: "partons"
  },
  {
    question: "Quel mot veut dire 'pencil'?",
    options: ["crayon", "stylo", "papier", "règle"],
    answer: "crayon"
  },
  {
    question: "Comment dit-on 'She is kind'?",
    options: ["Elle est gentille", "Elle gentille est", "Elle es gentille", "Elle est gentile"],
    answer: "Elle est gentille"
  },
  {
    question: "Que veut dire 'chambre'?",
    options: ["room", "chair", "lamp", "kitchen"],
    answer: "room"
  },
  {
    question: "Complétez: 'Les garçons _____ au football.'",
    options: ["jouent", "joue", "joues", "jouons"],
    answer: "jouent"
  },
  {
    question: "Quel est le pluriel de 'animal'?",
    options: ["animaux", "animals", "animales", "animaleses"],
    answer: "animaux"
  },
  {
    question: "Que signifie 'pluie'?",
    options: ["rain", "snow", "fog", "cloud"],
    answer: "rain"
  },
  {
    question: "Complétez: 'Je _____ mon livre chaque jour.'",
    options: ["lis", "lit", "lisez", "lisons"],
    answer: "lis"
  },
  {
    question: "Comment dit-on 'We are hungry' en français?",
    options: ["Nous avons faim", "Nous sont faim", "Nous est faim", "Nous a faim"],
    answer: "Nous avons faim"
  },
  {
    question: "Que veut dire 'pays'?",
    options: ["country", "city", "village", "continent"],
    answer: "country"
  },
  {
    question: "Complétez: 'Ils _____ leur repas à midi.'",
    options: ["prennent", "prend", "prenons", "prenez"],
    answer: "prennent"
  },
  {
    question: "Comment dit-on 'a tall boy'?",
    options: ["un garçon grand", "un grand garçon", "un garçon haut", "un haut garçon"],
    answer: "un grand garçon"
  },
  {
    question: "Que signifie 'ami'?",
    options: ["friend", "enemy", "student", "teacher"],
    answer: "friend"
  },
  {
    question: "Comment dit-on 'Monday' en français?",
    options: ["lundi", "mardi", "mercredi", "dimanche"],
    answer: "lundi"
  },
  {
    question: "Que signifie 'bibliothèque'?",
    options: ["library", "book", "school", "office"],
    answer: "library"
  },
  {
    question: "Complétez: 'Il _____ une belle maison.'",
    options: ["a", "as", "avons", "avez"],
    answer: "a"
  },
  {
    question: "Quel est le féminin de 'serveur'?",
    options: ["serveuse", "servante", "serveurine", "serviette"],
    answer: "serveuse"
  },
  {
    question: "Comment dit-on 'yellow' en français?",
    options: ["jaune", "rouge", "vert", "bleu"],
    answer: "jaune"
  },
  {
    question: "Que veut dire 'pantalon'?",
    options: ["trousers", "shirt", "shoes", "skirt"],
    answer: "trousers"
  },
  {
    question: "Complétez: 'Nous _____ à la maison après l'école.'",
    options: ["retournons", "retournez", "retourne", "retournez-nous"],
    answer: "retournons"
  },
  {
    question: "Comment dit-on 'kitchen' en français?",
    options: ["cuisine", "salon", "chambre", "garage"],
    answer: "cuisine"
  },
  {
    question: "Que signifie 'neige'?",
    options: ["snow", "rain", "fog", "storm"],
    answer: "snow"
  },
  {
    question: "Complétez: 'Vous _____ très intelligents.'",
    options: ["êtes", "sont", "es", "sommes"],
    answer: "êtes"
  },
  {
    question: "Quel mot correspond à 'doctor' en français?",
    options: ["médecin", "professeur", "juge", "avocat"],
    answer: "médecin"
  },
  {
    question: "Que veut dire 'chat'?",
    options: ["cat", "dog", "rat", "mouse"],
    answer: "cat"
  },
  {
    question: "Complétez: 'Je _____ au marché demain.'",
    options: ["vais", "va", "vas", "allons"],
    answer: "vais"
  },
  {
    question: "Comment dit-on 'tall tree' en français?",
    options: ["grand arbre", "arbre haut", "arbre grand", "hauteur arbre"],
    answer: "grand arbre"
  },
  {
    question: "Que signifie 'chapeau'?",
    options: ["hat", "shirt", "shoe", "jacket"],
    answer: "hat"
  },
  {
    question: "Complétez: 'Tu _____ un livre intéressant.'",
    options: ["lis", "lit", "lisons", "lisez"],
    answer: "lis"
  },
  {
    question: "Comment dit-on 'We are tired' en français?",
    options: ["Nous sommes fatigués", "Nous sommes fatigue", "Nous est fatigué", "Nous a fatigué"],
    answer: "Nous sommes fatigués"
  },
  {
    question: "Que veut dire 'chaud'?",
    options: ["hot", "cold", "warm", "cool"],
    answer: "hot"
  },
  {
    question: "Complétez: 'Il _____ au travail à huit heures.'",
    options: ["arrive", "arrives", "arrivent", "arrivons"],
    answer: "arrive"
  },
  {
    question: "Quel est le féminin de 'danseur'?",
    options: ["danseuse", "dansa", "danserine", "danserie"],
    answer: "danseuse"
  },
  {
    question: "Que signifie 'maison'?",
    options: ["house", "room", "building", "school"],
    answer: "house"
  },
  {
    question: "Complétez: 'Elles _____ les vêtements au marché.'",
    options: ["achètent", "achète", "achetons", "achetez"],
    answer: "achètent"
  },
  {
    question: "Comment dit-on 'student' en français?",
    options: ["élève", "étude", "école", "enseignant"],
    answer: "élève"
  },
  {
    question: "Que veut dire 'arbre'?",
    options: ["tree", "plant", "branch", "root"],
    answer: "tree"
  },
  {
    question: "Complétez: 'Je _____ très content aujourd’hui.'",
    options: ["suis", "es", "est", "sommes"],
    answer: "suis"
  },
  {
    question: "Quel est le contraire de 'facile'?",
    options: ["difficile", "rapide", "lourd", "petit"],
    answer: "difficile"
  },
  {
    question: "Comment dit-on 'knife' en français?",
    options: ["couteau", "fourchette", "assiette", "verre"],
    answer: "couteau"
  },
  {
    question: "Que signifie 'église'?",
    options: ["church", "mosque", "school", "temple"],
    answer: "church"
  },
  {
    question: "Complétez: 'Ils _____ leurs amis chaque week-end.'",
    options: ["voient", "voit", "voyez", "voyons"],
    answer: "voient"
  },
  {
    question: "Comment dit-on 'bathroom' en français?",
    options: ["salle de bain", "toilette", "chambre", "salon"],
    answer: "salle de bain"
  },
  {
    question: "Que veut dire 'chemin'?",
    options: ["path", "car", "floor", "wall"],
    answer: "path"
  },
  {
    question: "Complétez: 'Nous _____ un repas spécial aujourd’hui.'",
    options: ["préparons", "préparez", "prépare", "préparent"],
    answer: "préparons"
  },
  {
    question: "Quel mot est utilisé pour dire 'lazy'?",
    options: ["paresseux", "triste", "fatigué", "lent"],
    answer: "paresseux"
  },
  {
    question: "Comment dit-on 'airport' en français?",
    options: ["aéroport", "gare", "station", "port"],
    answer: "aéroport"
  },
  {
    question: "Que signifie 'travail'?",
    options: ["work", "travel", "study", "business"],
    answer: "work"
  },
  {
    question: "Complétez: 'Tu _____ souvent au cinéma?'",
    options: ["vas", "va", "allez", "allons"],
    answer: "vas"
  },
  {
    question: "Comment dit-on 'I understand' en français?",
    options: ["Je comprends", "Je comprendre", "J’ai compris", "Je suis comprendre"],
    answer: "Je comprends"
  },
  {
    question: "Que veut dire 'stylo'?",
    options: ["pen", "pencil", "paper", "book"],
    answer: "pen"
  },
  {
    question: "Complétez: 'Elle _____ son repas à midi.'",
    options: ["prend", "prends", "prenons", "prenez"],
    answer: "prend"
  },
  {
    question: "Quel est le féminin de 'acteur'?",
    options: ["actrice", "acteure", "actriceuse", "actessa"],
    answer: "actrice"
  },
  {
    question: "Comment dit-on 'Friday' en français?",
    options: ["vendredi", "jeudi", "samedi", "dimanche"],
    answer: "vendredi"
  },
  {
    question: "Que signifie 'heure'?",
    options: ["hour", "minute", "day", "week"],
    answer: "hour"
  },
  {
    question: "Complétez: 'Vous _____ un nouveau professeur.'",
    options: ["avez", "as", "avons", "a"],
    answer: "avez"
  },
  {
    question: "Quel mot signifie 'bicycle'?",
    options: ["vélo", "voiture", "train", "camion"],
    answer: "vélo"
  },
  {
    question: "Comment dit-on 'ice cream' en français?",
    options: ["glace", "fromage", "gâteau", "sucre"],
    answer: "glace"
  },
  {
    question: "Que veut dire 'route'?",
    options: ["road", "rail", "path", "highway"],
    answer: "road"
  },
  {
    question: "Complétez: 'Nous _____ français à l’école.'",
    options: ["apprenons", "apprenez", "apprends", "apprend"],
    answer: "apprenons"
  },
  {
    question: "Comment dit-on 'father' en français ?",
    options: ["Mère", "Père", "Frère", "Oncle"],
    answer: "Père"
  },
  {
    question: "Qui est la sœur de ta mère ?",
    options: ["Tante", "Cousine", "Grand-mère", "Nièce"],
    answer: "Tante"
  },
  {
    question: "Quel mot désigne les enfants de tes oncles et tantes ?",
    options: ["Cousins", "Frères", "Neveux", "Parents"],
    answer: "Cousins"
  },
  {
    question: "Comment appelle-t-on le fils de ton frère ?",
    options: ["Neveu", "Cousin", "Petit-fils", "Fils"],
    answer: "Neveu"
  },
  {
    question: "Ma mère est la _____ de mon père.",
    options: ["soeur", "femme", "tante", "nièce"],
    answer: "femme"
  },
  {
    question: "Quelle est la forme possessive de 'je' au masculin singulier ?",
    options: ["Ma", "Mes", "Mon", "Ton"],
    answer: "Mon"
  },
  {
    question: "Quelle phrase est correcte ?",
    options: [
      "Ma frère est gentil",
      "Mon sœur est grande",
      "Mon frère est intelligent",
      "Mes mère est belle"
    ],
    answer: "Mon frère est intelligent"
  },
  {
    question: "Le contraire de 'marié' est :",
    options: ["Jeune", "Petit", "Célibataire", "Vieux"],
    answer: "Célibataire"
  },
  {
    question: "Comment s'appelle la fille de ton fils ?",
    options: ["Nièce", "Petite-fille", "Cousine", "Sœur"],
    answer: "Petite-fille"
  },
  {
    question: "Comment dit-on 'grandmother' en français ?",
    options: ["Grand-mère", "Mère", "Tante", "Sœur"],
    answer: "Grand-mère"
  },
  {
    question: "Quel mot correspond au pluriel de 'enfant' ?",
    options: ["Enfances", "Enfants", "Enfantes", "Enfantesse"],
    answer: "Enfants"
  },
  {
    question: "Quelle phrase utilise bien les possessifs ?",
    options: [
      "Son sœur est médecin",
      "Sa frère est gentil",
      "Sa sœur est professeur",
      "Ses père est sévère"
    ],
    answer: "Sa sœur est professeur"
  },
  {
    question: "Ma cousine est la fille de ma _____.",
    options: ["sœur", "tante", "mère", "nièce"],
    answer: "tante"
  },
  {
    question: "Quel mot représente la famille proche ?",
    options: ["Famille nucléaire", "Famille élargie", "Famille nombreuse", "Famille étrangère"],
    answer: "Famille nucléaire"
  },
  {
    question: "Mon père et ma mère sont mes _____.",
    options: ["oncles", "parents", "frères", "cousins"],
    answer: "parents"
  },
  {
    question: "Ma mère est la _____ de ma grand-mère.",
    options: ["fille", "mère", "soeur", "cousine"],
    answer: "fille"
  },
  {
    question: "La famille élargie comprend :",
    options: ["Parents et enfants", "Grands-parents, oncles, tantes, cousins", "Seulement les cousins", "Frères et sœurs"],
    answer: "Grands-parents, oncles, tantes, cousins"
  },
  {
    question: "Quel adjectif possessif convient : '___ tante est gentille' ?",
    options: ["Mon", "Ma", "Mes", "Ton"],
    answer: "Ma"
  },
  {
    question: "Quel adjectif possessif convient : 'J'aime ___ cousins' ?",
    options: ["Mon", "Ma", "Mes", "Son"],
    answer: "Mes"
  },
  {
    question: "Le mot 'orphelin' signifie :",
    options: ["Un enfant sans famille", "Un enfant sans parents", "Un enfant malade", "Un enfant riche"],
    answer: "Un enfant sans parents"
  },
  {
    question: "Comment dit-on 'money' en français ?",
    options: ["Argent", "Pain", "Marché", "Prix"],
    answer: "Argent"
  },
  {
    question: "Quel mot signifie 'market' en français ?",
    options: ["Boutique", "Supermarché", "Marché", "Banque"],
    answer: "Marché"
  },
  {
    question: "Où achète-t-on du pain ?",
    options: ["Boulangerie", "Pharmacie", "Librairie", "Boucherie"],
    answer: "Boulangerie"
  },
  {
    question: "Comment dit-on 'to buy' en français ?",
    options: ["Acheter", "Vendre", "Payer", "Donner"],
    answer: "Acheter"
  },
  {
    question: "Quel est le contraire de 'acheter' ?",
    options: ["Compter", "Vendre", "Avoir", "Chercher"],
    answer: "Vendre"
  },
  {
    question: "Comment dit-on 'how much does it cost?' en français ?",
    options: ["Combien coûte-t-il ?", "Où est-ce ?", "Qu'est-ce que c'est ?", "Il y a quoi ?"],
    answer: "Combien coûte-t-il ?"
  },
  {
    question: "Le client paie avec :",
    options: ["Une carte", "Une boîte", "Un sac", "Un stylo"],
    answer: "Une carte"
  },
  {
    question: "Que signifie 'prix' ?",
    options: ["Montant à payer", "Poids", "Magasin", "Produit"],
    answer: "Montant à payer"
  },
  {
    question: "Que vend-on dans une boucherie ?",
    options: ["Des légumes", "Du pain", "De la viande", "Des livres"],
    answer: "De la viande"
  },
  {
    question: "Quel mot ne correspond pas ?",
    options: ["Acheter", "Vendre", "Marcher", "Payer"],
    answer: "Marcher"
  },
  {
    question: "Quelle phrase est correcte ?",
    options: [
      "Je vais acheter un robe.",
      "Tu vas achetez un fruit.",
      "Il va acheter une chemise.",
      "Nous achetons une pain."
    ],
    answer: "Il va acheter une chemise."
  },
  {
    question: "On va au _____ pour acheter des médicaments.",
    options: ["Marché", "Pharmacie", "Librairie", "Boucherie"],
    answer: "Pharmacie"
  },
  {
    question: "Que signifie 'faire les courses' ?",
    options: ["Manger", "Acheter des choses", "Faire du sport", "Étudier"],
    answer: "Acheter des choses"
  },
  {
    question: "Comment s'appelle une personne qui vend ?",
    options: ["Client", "Acheteur", "Vendeur", "Marché"],
    answer: "Vendeur"
  },
  {
    question: "Que veut dire 'trop cher' ?",
    options: ["Pas assez cher", "Bon marché", "Coûte beaucoup", "Gratuit"],
    answer: "Coûte beaucoup"
  },
  {
    question: "Quel mot complète : 'Je veux _____ ce pantalon.'",
    options: ["prendre", "vendre", "acheter", "marcher"],
    answer: "acheter"
  },
  {
    question: "Une promotion signifie :",
    options: ["Une hausse de prix", "Un rabais", "Un nouveau produit", "Un produit abîmé"],
    answer: "Un rabais"
  },
  {
    question: "Que fait-on à la caisse ?",
    options: ["On mange", "On dort", "On paie", "On regarde"],
    answer: "On paie"
  },
  {
    question: "Quel est le mot français pour 'change' (monnaie rendue) ?",
    options: ["Billet", "Argent", "Rendu", "Monnaie"],
    answer: "Monnaie"
  },
  {
    question: "Quel mot désigne un endroit où on vend tout ?",
    options: ["Boulangerie", "Supermarché", "Pharmacie", "Librairie"],
    answer: "Supermarché"
  },
  {
    question: "Comment dit-on 'weather' en français ?",
    options: ["Climat", "Vent", "Temps", "Chaleur"],
    answer: "Temps"
  },
  {
    question: "Quel mot signifie 'climate' en français ?",
    options: ["Tempête", "Saison", "Climat", "Pluie"],
    answer: "Climat"
  },
  {
    question: "Quel est le mot français pour 'rain' ?",
    options: ["Soleil", "Pluie", "Neige", "Orage"],
    answer: "Pluie"
  },
  {
    question: "Il fait très chaud aujourd'hui. Quelle phrase est correcte ?",
    options: ["Il pleut", "Il fait froid", "Il neige", "Il fait chaud"],
    answer: "Il fait chaud"
  },
  {
    question: "Quel mot désigne 'storm' en français ?",
    options: ["Orage", "Brise", "Vent", "Éclaircie"],
    answer: "Orage"
  },
  {
    question: "Comment dit-on 'sunny' en français ?",
    options: ["Nuageux", "Orageux", "Ensoleillé", "Humide"],
    answer: "Ensoleillé"
  },
  {
    question: "Quel est le contraire de 'froid' ?",
    options: ["Humide", "Chaud", "Pluvieux", "Glacé"],
    answer: "Chaud"
  },
  {
    question: "Il neige beaucoup. Que portons-nous ?",
    options: ["Un short", "Un maillot", "Un manteau", "Un débardeur"],
    answer: "Un manteau"
  },
  {
    question: "Comment s'appelle une période de l’année avec un type de temps spécifique ?",
    options: ["Journée", "Climat", "Saison", "Orage"],
    answer: "Saison"
  },
  {
    question: "Que signifie 'le vent souffle fort' ?",
    options: ["Il pleut", "Il neige", "Il y a du soleil", "Il y a beaucoup de vent"],
    answer: "Il y a beaucoup de vent"
  },
  {
    question: "Quel temps fait-il en été en général ?",
    options: ["Il fait froid", "Il neige", "Il fait chaud", "Il pleut tout le temps"],
    answer: "Il fait chaud"
  },
  {
    question: "Quel temps fait-il en hiver ?",
    options: ["Il fait chaud", "Il fait frais", "Il neige", "Il fait beau"],
    answer: "Il neige"
  },
  {
    question: "Quel est le mot français pour 'cloudy' ?",
    options: ["Pluvieux", "Ensoleillé", "Nuageux", "Brumeux"],
    answer: "Nuageux"
  },
  {
    question: "La météo annonce : 'Il fera beau'. Cela veut dire :",
    options: ["Il y aura de la pluie", "Il fera froid", "Il fera mauvais", "Il y aura du soleil"],
    answer: "Il y aura du soleil"
  },
  {
    question: "Que signifie 'il fait frais' ?",
    options: ["Il fait très chaud", "Il fait un peu froid", "Il neige", "Il pleut fort"],
    answer: "Il fait un peu froid"
  },
  {
    question: "Que portons-nous quand il pleut ?",
    options: ["Lunettes de soleil", "Un imperméable", "Un short", "Des sandales"],
    answer: "Un imperméable"
  },
  {
    question: "Quel mot correspond à 'fog' en français ?",
    options: ["Brouillard", "Foudre", "Tonnerre", "Vent"],
    answer: "Brouillard"
  },
  {
    question: "Quand il y a de la foudre, il peut aussi y avoir :",
    options: ["Un arc-en-ciel", "De la neige", "Un orage", "Du brouillard"],
    answer: "Un orage"
  },
  {
    question: "Quel est le mot pour 'thunder' en français ?",
    options: ["Tonnerre", "Foudre", "Vent", "Neige"],
    answer: "Tonnerre"
  },
  {
    question: "Quand il y a un arc-en-ciel, cela signifie souvent :",
    options: ["Une tempête approche", "La pluie s'est arrêtée", "Il neige", "Il fait nuit"],
    answer: "La pluie s'est arrêtée"
  },
  {
    question: "Comment dit-on 'body' en français ?",
    options: ["Santé", "Corps", "Tête", "Peau"],
    answer: "Corps"
  },
  {
    question: "Quel est l’organe principal de la pensée ?",
    options: ["Le cœur", "Le cerveau", "Les yeux", "Le nez"],
    answer: "Le cerveau"
  },
  {
    question: "Combien de jambes a un être humain ?",
    options: ["Quatre", "Deux", "Trois", "Une"],
    answer: "Deux"
  },
  {
    question: "Quel organe est responsable de la respiration ?",
    options: ["Les reins", "Le cœur", "Les poumons", "Le foie"],
    answer: "Les poumons"
  },
  {
    question: "Quelle partie du corps sert à entendre ?",
    options: ["Les yeux", "Les oreilles", "Le nez", "Les doigts"],
    answer: "Les oreilles"
  },
  {
    question: "Comment dit-on 'hand' en français ?",
    options: ["Tête", "Main", "Pied", "Jambe"],
    answer: "Main"
  },
  {
    question: "Quelle est la bonne hygiène bucco-dentaire ?",
    options: [
      "Se brosser les dents une fois par semaine",
      "Ne jamais aller chez le dentiste",
      "Se brosser les dents deux fois par jour",
      "Utiliser un cure-dent seulement"
    ],
    answer: "Se brosser les dents deux fois par jour"
  },
  {
    question: "Quel aliment est bon pour les os ?",
    options: ["Le riz", "Le lait", "Le beurre", "Le pain"],
    answer: "Le lait"
  },
  {
    question: "Que faut-il faire pour rester en bonne santé ?",
    options: ["Manger trop de sucreries", "Faire du sport", "Dormir peu", "Fumer"],
    answer: "Faire du sport"
  },
  {
    question: "Quel organe pompe le sang dans le corps ?",
    options: ["Le cerveau", "Le foie", "Le cœur", "Les poumons"],
    answer: "Le cœur"
  },
  {
    question: "Comment dit-on 'eye' en français ?",
    options: ["Bouche", "Nez", "Oeil", "Oreille"],
    answer: "Oeil"
  },
  {
    question: "Quel est le rôle de l’estomac ?",
    options: [
      "Voir les choses",
      "Entendre les sons",
      "Digérer les aliments",
      "Faire battre le cœur"
    ],
    answer: "Digérer les aliments"
  },
  {
    question: "Qu’est-ce qui est essentiel pour une bonne santé ?",
    options: ["L'alcool", "Les légumes", "Les bonbons", "Le stress"],
    answer: "Les légumes"
  },
  {
    question: "Que doit-on faire après être allé aux toilettes ?",
    options: ["Dormir", "Boire de l'eau", "Se laver les mains", "Rien du tout"],
    answer: "Se laver les mains"
  },
  {
    question: "Comment dit-on 'leg' en français ?",
    options: ["Bras", "Tête", "Jambe", "Main"],
    answer: "Jambe"
  },
  {
    question: "Qu’est-ce que la grippe ?",
    options: ["Une boisson", "Une maladie", "Un aliment", "Un sport"],
    answer: "Une maladie"
  },
  {
    question: "Quand on est malade, on va voir :",
    options: ["Le professeur", "Le dentiste", "Le docteur", "Le boulanger"],
    answer: "Le docteur"
  },
  {
    question: "Quel fruit contient beaucoup de vitamine C ?",
    options: ["Banane", "Pomme", "Orange", "Poire"],
    answer: "Orange"
  },
  {
    question: "Quelle boisson est la plus saine ?",
    options: ["Soda", "Eau", "Café", "Vin"],
    answer: "Eau"
  },
  {
    question: "Quelle partie du corps bat en rythme ?",
    options: ["Le foie", "Le cœur", "Les poumons", "L’estomac"],
    answer: "Le cœur"
  },
  {
    question: "Comment s'appelle une personne qui soigne les malades ?",
    options: ["Un avocat", "Un médecin", "Un boulanger", "Un professeur"],
    answer: "Un médecin"
  },
  {
    question: "Où travaille le professeur ?",
    options: ["À l'hôpital", "À l'école", "Au marché", "Au poste de police"],
    answer: "À l'école"
  },
  {
    question: "Qui éteint les incendies ?",
    options: ["Le policier", "Le facteur", "Le pompier", "Le pilote"],
    answer: "Le pompier"
  },
  {
    question: "Comment s'appelle une personne qui fait du pain ?",
    options: ["Un boucher", "Un boulanger", "Un peintre", "Un coiffeur"],
    answer: "Un boulanger"
  },
  {
    question: "Où travaille le médecin ?",
    options: ["Au marché", "À l'école", "À l’hôpital", "Au stade"],
    answer: "À l’hôpital"
  },
  {
    question: "Quelle profession enseigne à l'école ?",
    options: ["Le docteur", "Le professeur", "Le pilote", "Le mécanicien"],
    answer: "Le professeur"
  },
  {
    question: "Qui répare les voitures ?",
    options: ["Le plombier", "Le mécanicien", "Le cuisinier", "Le boucher"],
    answer: "Le mécanicien"
  },
  {
    question: "Comment s'appelle une personne qui coupe les cheveux ?",
    options: ["Le coiffeur", "Le dentiste", "Le couturier", "Le facteur"],
    answer: "Le coiffeur"
  },
  {
    question: "Où travaille le coiffeur ?",
    options: ["Dans un salon de coiffure", "Dans un restaurant", "À l’école", "À la pharmacie"],
    answer: "Dans un salon de coiffure"
  },
  {
    question: "Qui fait la cuisine dans un restaurant ?",
    options: ["Le serveur", "Le médecin", "Le cuisinier", "Le pharmacien"],
    answer: "Le cuisinier"
  },
  {
    question: "Comment s'appelle une personne qui vend des médicaments ?",
    options: ["Le dentiste", "Le pharmacien", "Le policier", "Le vétérinaire"],
    answer: "Le pharmacien"
  },
  {
    question: "Où travaille le pharmacien ?",
    options: ["À la pharmacie", "À l'école", "Au garage", "Au commissariat"],
    answer: "À la pharmacie"
  },
  {
    question: "Qui protège la population ?",
    options: ["Le médecin", "Le policier", "Le cuisinier", "Le coiffeur"],
    answer: "Le policier"
  },
  {
    question: "Quel professionnel transporte les passagers dans un avion ?",
    options: ["Le chauffeur", "Le pilote", "Le fermier", "Le facteur"],
    answer: "Le pilote"
  },
  {
    question: "Qui travaille dans un tribunal ?",
    options: ["Le professeur", "Le juge", "Le pompier", "Le médecin"],
    answer: "Le juge"
  },
  {
    question: "Comment s'appelle une personne qui écrit des lettres et les envoie ?",
    options: ["Un facteur", "Un docteur", "Un pilote", "Un avocat"],
    answer: "Un facteur"
  },
  {
    question: "Où travaille le facteur ?",
    options: ["À l’aéroport", "À l’école", "À la poste", "À l’hôpital"],
    answer: "À la poste"
  },
  {
    question: "Qui cultive la terre ?",
    options: ["Le fermier", "Le pilote", "Le juge", "Le pompier"],
    answer: "Le fermier"
  },
  {
    question: "Où travaille le fermier ?",
    options: ["À la banque", "À la ferme", "À la pharmacie", "Au tribunal"],
    answer: "À la ferme"
  },
  {
    question: "Quel professionnel soigne les dents ?",
    options: ["Le docteur", "Le dentiste", "Le pharmacien", "Le pompier"],
    answer: "Le dentiste"
  },
  {
    question: "Quel est un exemple de loisir ?",
    options: ["Faire ses devoirs", "Regarder un film", "Faire la vaisselle", "Travailler au bureau"],
    answer: "Regarder un film"
  },
  {
    question: "Comment appelle-t-on une activité sportive avec un ballon rond ?",
    options: ["Le tennis", "Le volley", "Le football", "La natation"],
    answer: "Le football"
  },
  {
    question: "Quel sport se pratique dans une piscine ?",
    options: ["La boxe", "La natation", "Le handball", "Le cyclisme"],
    answer: "La natation"
  },
  {
    question: "Que fait-on dans un théâtre ?",
    options: ["On joue au foot", "On regarde une pièce", "On nage", "On lit un livre"],
    answer: "On regarde une pièce"
  },
  {
    question: "Quel sport utilise une raquette et une balle jaune ?",
    options: ["Le rugby", "Le tennis", "Le basket", "Le foot"],
    answer: "Le tennis"
  },
  {
    question: "Quel loisir consiste à lire des livres ?",
    options: ["La natation", "La lecture", "La danse", "La peinture"],
    answer: "La lecture"
  },
  {
    question: "Quel est un loisir artistique ?",
    options: ["Le cyclisme", "La peinture", "Le football", "Le basket"],
    answer: "La peinture"
  },
  {
    question: "Quel sport utilise un vélo ?",
    options: ["Le judo", "Le cyclisme", "Le ski", "La boxe"],
    answer: "Le cyclisme"
  },
  {
    question: "Quel est un loisir calme ?",
    options: ["Le football", "La lecture", "Le rugby", "La boxe"],
    answer: "La lecture"
  },
  {
    question: "Quel sport se joue avec les mains et un panier ?",
    options: ["Le football", "Le basket", "Le tennis", "Le judo"],
    answer: "Le basket"
  },
  {
    question: "Quel loisir utilise une caméra ?",
    options: ["La photographie", "Le rugby", "Le tennis", "La course"],
    answer: "La photographie"
  },
  {
    question: "Quel sport implique souvent une piscine ?",
    options: ["La lutte", "La natation", "Le basket", "La gymnastique"],
    answer: "La natation"
  },
  {
    question: "Quel sport se joue à onze contre onze ?",
    options: ["Le volley", "Le tennis", "Le football", "Le judo"],
    answer: "Le football"
  },
  {
    question: "Comment appelle-t-on une personne qui aime faire du dessin ?",
    options: ["Un nageur", "Un peintre", "Un joueur", "Un chanteur"],
    answer: "Un peintre"
  },
  {
    question: "Quel sport utilise un ballon ovale ?",
    options: ["Le basket", "Le rugby", "Le tennis", "Le handball"],
    answer: "Le rugby"
  },
  {
    question: "Où joue-t-on au tennis ?",
    options: ["Dans une piscine", "Sur un terrain", "Dans un stade", "Sur un court"],
    answer: "Sur un court"
  },
  {
    question: "Quel loisir consiste à écouter de la musique ?",
    options: ["La lecture", "Le dessin", "L’écoute musicale", "Le football"],
    answer: "L’écoute musicale"
  },
  {
    question: "Quel sport se pratique sur un ring ?",
    options: ["Le volley", "La boxe", "Le basket", "Le cyclisme"],
    answer: "La boxe"
  },
  {
    question: "Quel est un loisir populaire chez les jeunes ?",
    options: ["La pêche", "Le jardinage", "Les jeux vidéo", "La couture"],
    answer: "Les jeux vidéo"
  },
  {
    question: "Comment s'appelle une personne qui chante ?",
    options: ["Un acteur", "Un musicien", "Un chanteur", "Un peintre"],
    answer: "Un chanteur"
  },
  {
    question: "Qu'est-ce qu'une fête traditionnelle ?",
    options: ["Une réunion d'école", "Une célébration culturelle", "Une compétition", "Une émission télévisée"],
    answer: "Une célébration culturelle"
  },
  {
    question: "Quelle fête célèbre la naissance de Jésus ?",
    options: ["Pâques", "Le Nouvel An", "Noël", "La Pentecôte"],
    answer: "Noël"
  },
  {
    question: "Quand célèbre-t-on le Nouvel An ?",
    options: ["25 décembre", "14 février", "1er janvier", "15 août"],
    answer: "1er janvier"
  },
  {
    question: "Quelle fête est associée aux œufs en chocolat ?",
    options: ["La Toussaint", "Pâques", "La fête nationale", "La Saint-Valentin"],
    answer: "Pâques"
  },
  {
    question: "Quelle fête est dédiée aux amoureux ?",
    options: ["Pâques", "Noël", "La Saint-Valentin", "Le Ramadan"],
    answer: "La Saint-Valentin"
  },
  {
    question: "Que porte-t-on souvent lors d'une fête traditionnelle ?",
    options: ["Un uniforme", "Un costume traditionnel", "Un pyjama", "Une robe de mariée"],
    answer: "Un costume traditionnel"
  },
  {
    question: "Que fait-on pendant une fête religieuse ?",
    options: ["On fait du sport", "On joue de la musique", "On prie et on célèbre", "On cuisine uniquement"],
    answer: "On prie et on célèbre"
  },
  {
    question: "Quelle fête musulmane marque la fin du jeûne du Ramadan ?",
    options: ["La Pentecôte", "L’Aïd el-Fitr", "Le carême", "La Toussaint"],
    answer: "L’Aïd el-Fitr"
  },
  {
    question: "Comment appelle-t-on une fête nationale en France ?",
    options: ["La fête de la musique", "La fête du travail", "La fête de la liberté", "La fête nationale"],
    answer: "La fête nationale"
  },
  {
    question: "Quelle fête est connue pour les feux d'artifice en France ?",
    options: ["Noël", "14 juillet", "Pâques", "1er mai"],
    answer: "14 juillet"
  },
  {
    question: "Qu’est-ce qu’un rite ?",
    options: ["Une chanson", "Une activité religieuse ou culturelle", "Un sport", "Une danse rapide"],
    answer: "Une activité religieuse ou culturelle"
  },
  {
    question: "Quelle est une coutume pendant les mariages ?",
    options: ["Manger des œufs", "Allumer des feux d'artifice", "Danser et faire des cadeaux", "Dormir à l'église"],
    answer: "Danser et faire des cadeaux"
  },
  {
    question: "Quelle fête chrétienne célèbre la résurrection de Jésus ?",
    options: ["Pâques", "Noël", "La Toussaint", "La Pentecôte"],
    answer: "Pâques"
  },
  {
    question: "Comment célèbre-t-on souvent les fêtes ?",
    options: ["En travaillant", "En restant seul", "En famille et avec des amis", "En faisant les devoirs"],
    answer: "En famille et avec des amis"
  },
  {
    question: "Quelle fête honore les morts ?",
    options: ["La Pentecôte", "La Toussaint", "Le Ramadan", "La Saint-Jean"],
    answer: "La Toussaint"
  },
  {
    question: "Quel plat est souvent préparé pendant les fêtes en Afrique ?",
    options: ["Le couscous", "Le riz jollof", "Les frites", "Les crêpes"],
    answer: "Le riz jollof"
  },
  {
    question: "Pourquoi célèbre-t-on les fêtes ?",
    options: ["Pour apprendre", "Pour travailler", "Pour se divertir et se souvenir", "Pour rester en silence"],
    answer: "Pour se divertir et se souvenir"
  },
  {
    question: "Quelle fête célèbre les travailleurs ?",
    options: ["La fête nationale", "Le Nouvel An", "La fête du travail", "Pâques"],
    answer: "La fête du travail"
  },
  {
    question: "Quel est un exemple de costume traditionnel ghanéen ?",
    options: ["Le kimono", "Le kente", "Le sari", "Le béret"],
    answer: "Le kente"
  },
  {
    question: "Que font souvent les enfants pendant les fêtes ?",
    options: ["Ils dorment", "Ils vont à l'école", "Ils jouent et chantent", "Ils lisent des romans"],
    answer: "Ils jouent et chantent"
  },
  {
    question: "Quel est le travail d’un enseignant ?",
    options: ["Soigner les malades", "Éduquer les élèves", "Vendre des produits", "Conduire un taxi"],
    answer: "Éduquer les élèves"
  },
  {
    question: "Comment appelle-t-on une personne qui soigne les malades ?",
    options: ["Un avocat", "Un médecin", "Un pilote", "Un agriculteur"],
    answer: "Un médecin"
  },
  {
    question: "Qui répare les voitures ?",
    options: ["Le plombier", "Le boulanger", "Le mécanicien", "Le pharmacien"],
    answer: "Le mécanicien"
  },
  {
    question: "Quelle est la profession d’une personne qui construit des maisons ?",
    options: ["Un maçon", "Un coiffeur", "Un juge", "Un poète"],
    answer: "Un maçon"
  },
  {
    question: "Qui prépare le pain dans une boulangerie ?",
    options: ["Le pâtissier", "Le boulanger", "Le cuisinier", "Le serveur"],
    answer: "Le boulanger"
  },
  {
    question: "Comment appelle-t-on une personne qui défend les gens en justice ?",
    options: ["Un juge", "Un avocat", "Un douanier", "Un enseignant"],
    answer: "Un avocat"
  },
  {
    question: "Quel est le rôle d’un policier ?",
    options: ["Soigner", "Cuisiner", "Faire régner l’ordre", "Peindre des murs"],
    answer: "Faire régner l’ordre"
  },
  {
    question: "Qui vend des médicaments ?",
    options: ["Le dentiste", "Le pharmacien", "Le pilote", "Le boucher"],
    answer: "Le pharmacien"
  },
  {
    question: "Quelle profession travaille dans les champs ?",
    options: ["Le menuisier", "L’agriculteur", "Le secrétaire", "Le plombier"],
    answer: "L’agriculteur"
  },
  {
    question: "Que fait un coiffeur ?",
    options: ["Vérifie les comptes", "Coupe les cheveux", "Répare les tuyaux", "Joue au football"],
    answer: "Coupe les cheveux"
  },
  {
    question: "Qui vole un avion ?",
    options: ["Le pilote", "Le marin", "Le conducteur", "Le commerçant"],
    answer: "Le pilote"
  },
  {
    question: "Qui soigne les dents ?",
    options: ["Le pharmacien", "Le dentiste", "Le boulanger", "Le musicien"],
    answer: "Le dentiste"
  },
  {
    question: "Que fait un musicien ?",
    options: ["Crée des vêtements", "Joue de la musique", "Conduit une voiture", "Répare les murs"],
    answer: "Joue de la musique"
  },
  {
    question: "Quel métier est exercé dans une salle de classe ?",
    options: ["Policier", "Enseignant", "Médecin", "Menuisier"],
    answer: "Enseignant"
  },
  {
    question: "Qui aide à la naissance des bébés ?",
    options: ["L’ingénieur", "La sage-femme", "Le jardinier", "Le mécanicien"],
    answer: "La sage-femme"
  },
  {
    question: "Qui travaille dans un tribunal ?",
    options: ["Le juge", "Le pêcheur", "Le peintre", "Le menuisier"],
    answer: "Le juge"
  },
  {
    question: "Quelle profession vend des objets au marché ?",
    options: ["Le commerçant", "Le médecin", "L’infirmier", "Le pilote"],
    answer: "Le commerçant"
  },
  {
    question: "Qui fabrique des meubles ?",
    options: ["Le menuisier", "Le couturier", "Le coiffeur", "Le pâtissier"],
    answer: "Le menuisier"
  },
  {
    question: "Que fait un jardinier ?",
    options: ["Il répare les ordinateurs", "Il cultive les plantes", "Il joue de la musique", "Il vend des habits"],
    answer: "Il cultive les plantes"
  },
  {
    question: "Quel métier nécessite l’usage d’un ordinateur dans un bureau ?",
    options: ["Le secrétaire", "Le pêcheur", "Le maçon", "Le chauffeur"],
    answer: "Le secrétaire"
  },
  {
    question: "Quel est le principal moyen de communication utilisé pour parler à quelqu'un au loin ?",
    options: ["La télévision", "Le téléphone", "La radio", "Le journal"],
    answer: "Le téléphone"
  },
  {
    question: "Quel appareil permet d'envoyer des messages électroniques rapidement ?",
    options: ["Le téléviseur", "L'ordinateur", "Le frigo", "La lampe"],
    answer: "L'ordinateur"
  },
  {
    question: "Lequel de ces moyens est utilisé pour envoyer une lettre ?",
    options: ["Le téléphone", "La poste", "La radio", "Le journal"],
    answer: "La poste"
  },
  {
    question: "Quel moyen de communication utilise l’image et le son ?",
    options: ["La radio", "Le téléphone", "La télévision", "Le fax"],
    answer: "La télévision"
  },
  {
    question: "Quel est le rôle principal de la radio ?",
    options: [
      "Envoyer des colis",
      "Diffuser des informations sonores",
      "Afficher des images",
      "Écrire des lettres"
    ],
    answer: "Diffuser des informations sonores"
  },
  {
    question: "Quel outil est nécessaire pour écrire une lettre ?",
    options: ["Un téléphone", "Une enveloppe", "Une télécommande", "Un micro"],
    answer: "Une enveloppe"
  },
  {
    question: "Quel moyen de communication est le plus rapide aujourd’hui ?",
    options: ["La lettre", "Le téléphone", "Le pigeon", "Le journal"],
    answer: "Le téléphone"
  },
  {
    question: "Quel est l’avantage de l’Internet ?",
    options: [
      "Il est lent",
      "Il permet de voyager",
      "Il facilite la communication rapide",
      "Il remplace les livres"
    ],
    answer: "Il facilite la communication rapide"
  },
  {
    question: "Que signifie « e-mail » en français ?",
    options: ["Lettre électronique", "Téléphone mobile", "Message vocal", "Clavier virtuel"],
    answer: "Lettre électronique"
  },
  {
    question: "Quel objet utilise-t-on pour prendre un appel téléphonique ?",
    options: ["Une radio", "Un téléphone", "Une imprimante", "Un cahier"],
    answer: "Un téléphone"
  },
  {
    question: "Quel moyen de communication est utilisé dans les journaux ?",
    options: ["La parole", "L’image seulement", "L’écriture", "La musique"],
    answer: "L’écriture"
  },
  {
    question: "Lequel de ces moyens est une forme de communication écrite ?",
    options: ["Le téléphone", "L’e-mail", "La télévision", "La radio"],
    answer: "L’e-mail"
  },
  {
    question: "Quel est l'inconvénient principal du courrier postal ?",
    options: ["Il est rapide", "Il est bruyant", "Il est lent", "Il est visuel"],
    answer: "Il est lent"
  },
  {
    question: "Quelle invention a permis la communication mobile ?",
    options: ["La télévision", "Le téléphone portable", "La radio", "Le tableau"],
    answer: "Le téléphone portable"
  },
  {
    question: "Quel appareil permet la visioconférence ?",
    options: ["Une radio", "Un téléphone fixe", "Un ordinateur", "Un livre"],
    answer: "Un ordinateur"
  },
  {
    question: "Quel moyen est souvent utilisé pour les publicités ?",
    options: ["Les journaux", "Les livres", "Les lettres", "Les carnets"],
    answer: "Les journaux"
  },
  {
    question: "Lequel n’est pas un moyen de communication ?",
    options: ["Le bus", "Le téléphone", "L’ordinateur", "La radio"],
    answer: "Le bus"
  },
  {
    question: "Comment appelle-t-on la personne qui remet les lettres ?",
    options: ["Un médecin", "Un facteur", "Un conducteur", "Un vendeur"],
    answer: "Un facteur"
  },
  {
    question: "Lequel de ces outils permet d’envoyer des documents imprimés ?",
    options: ["Le fax", "Le micro", "La télévision", "La radio"],
    answer: "Le fax"
  },
  {
    question: "Le journal est un moyen de communication...",
    options: ["Sonore", "Visuel et écrit", "Oral", "Électronique seulement"],
    answer: "Visuel et écrit"
  },
  {
    question: "Comment dit-on 'shoes' en français ?",
    options: ["Les chaussures", "Les chaussettes", "Les pantalons", "Les jupes"],
    answer: "Les chaussures"
  },
  {
    question: "Quel vêtement porte-t-on pour nager ?",
    options: ["Le maillot de bain", "Le manteau", "Le jean", "La cravate"],
    answer: "Le maillot de bain"
  },
  {
    question: "Quelle phrase signifie 'I wear a blue shirt' en français ?",
    options: ["Je porte une chemise bleue", "Je porte une jupe bleue", "Je mange une chemise bleue", "Je lave une chemise bleue"],
    answer: "Je porte une chemise bleue"
  },
  {
    question: "Où dort-on dans la maison ?",
    options: ["Dans la chambre", "Dans la cuisine", "Dans la salle de bain", "Dans le garage"],
    answer: "Dans la chambre"
  },
  {
    question: "Comment appelle-t-on l’endroit où on prépare les repas ?",
    options: ["La cuisine", "La salle de séjour", "La chambre", "La cave"],
    answer: "La cuisine"
  },
  {
    question: "Quel meuble trouve-t-on dans la salle à manger ?",
    options: ["La table", "Le lit", "Le canapé", "La baignoire"],
    answer: "La table"
  },
  {
    question: "Quel objet utilise-t-on pour écrire ?",
    options: ["Un stylo", "Une chaise", "Une règle", "Un tableau"],
    answer: "Un stylo"
  },
  {
    question: "Quelle phrase veut dire 'The teacher is in the classroom' ?",
    options: ["Le professeur est dans la salle de classe", "Le professeur est à la maison", "Le professeur est à l’école", "Le professeur est dans le bureau"],
    answer: "Le professeur est dans la salle de classe"
  },
  {
    question: "Comment appelle-t-on un livre qu’on lit à l’école ?",
    options: ["Un manuel", "Un cahier", "Une trousse", "Un cartable"],
    answer: "Un manuel"
  },
  {
    question: "Quel sport se joue avec un ballon rond ?",
    options: ["Le football", "La natation", "Le cyclisme", "Le tennis"],
    answer: "Le football"
  },
  {
    question: "Que fait-on à la piscine ?",
    options: ["On nage", "On court", "On chante", "On mange"],
    answer: "On nage"
  },
  {
    question: "Quel loisir implique des livres ?",
    options: ["La lecture", "La course", "La natation", "Le dessin"],
    answer: "La lecture"
  },
  {
    question: "Quel est le moyen de transport le plus rapide ?",
    options: ["L’avion", "La bicyclette", "Le bateau", "La voiture"],
    answer: "L’avion"
  },
  {
    question: "Comment appelle-t-on un transport en commun terrestre ?",
    options: ["Le bus", "L’avion", "Le bateau", "Le métro"],
    answer: "Le bus"
  },
  {
    question: "Où va-t-on pour prendre le train ?",
    options: ["À la gare", "À l’aéroport", "À l’école", "Au marché"],
    answer: "À la gare"
  },
  {
    question: "Quel moyen de communication utilise un téléphone ?",
    options: ["Un appel", "Un livre", "Une affiche", "Une réunion"],
    answer: "Un appel"
  },
  {
    question: "Quel outil utilise-t-on pour écrire une lettre électronique ?",
    options: ["Un ordinateur", "Une radio", "Un crayon", "Un journal"],
    answer: "Un ordinateur"
  },
  {
    question: "Comment s'appelle un message court envoyé par téléphone ?",
    options: ["Un SMS", "Un email", "Une lettre", "Une affiche"],
    answer: "Un SMS"
  },
  {
    question: "Comment dit-on 'newspaper' en français ?",
    options: ["Un journal", "Un livre", "Un cahier", "Un stylo"],
    answer: "Un journal"
  },
  {
    question: "Quelle est la capitale de la France ?",
    options: ["Paris", "Lyon", "Marseille", "Nice"],
    answer: "Paris"
  },
  {
    question: "Comment s’appelle le président actuel de la France (2025) ?",
    options: ["Emmanuel Macron", "François Hollande", "Nicolas Sarkozy", "Jacques Chirac"],
    answer: "Emmanuel Macron"
  },
  {
    question: "Quel est le symbole national de la France ?",
    options: ["Le coq", "L’aigle", "Le lion", "Le tigre"],
    answer: "Le coq"
  },
  {
    question: "Que veut dire 'Bonjour' ?",
    options: ["Hello", "Goodbye", "Please", "Thank you"],
    answer: "Hello"
  },
  {
    question: "Quelle est la traduction de 'merci' ?",
    options: ["Thank you", "Please", "Sorry", "Hello"],
    answer: "Thank you"
  },
  {
    question: "Comment dit-on 'I am hungry' en français ?",
    options: ["J’ai faim", "Je suis fatigué", "Je suis en colère", "Je suis malade"],
    answer: "J’ai faim"
  },
  {
    question: "Quelle est la couleur du ciel pendant une journée ensoleillée ?",
    options: ["Bleu", "Rouge", "Vert", "Noir"],
    answer: "Bleu"
  },
  {
    question: "Quel jour suit lundi ?",
    options: ["Mardi", "Mercredi", "Jeudi", "Vendredi"],
    answer: "Mardi"
  },
  {
    question: "Combien de mois y a-t-il dans une année ?",
    options: ["12", "10", "11", "13"],
    answer: "12"
  },
  {
    question: "Comment dit-on 'I am tired' en français ?",
    options: ["Je suis fatigué", "J’ai sommeil", "Je suis content", "Je suis fâché"],
    answer: "Je suis fatigué"
  },
  {
    question: "Quelle est la bonne traduction de 'I have a headache' ?",
    options: ["J’ai mal à la tête", "J’ai mal au bras", "J’ai mal au ventre", "J’ai faim"],
    answer: "J’ai mal à la tête"
  },
  {
    question: "Quel est le contraire de 'grand' ?",
    options: ["Petit", "Fort", "Lourd", "Beau"],
    answer: "Petit"
  },
  {
    question: "Quel est le féminin de 'acteur' ?",
    options: ["Actrice", "Acteuse", "Actine", "Acta"],
    answer: "Actrice"
  },
  {
    question: "Quelle est la forme plurielle de 'chien' ?",
    options: ["Chiens", "Chienes", "Chien", "Chienn"],
    answer: "Chiens"
  },
  {
    question: "Comment dit-on 'We are going to the market' en français ?",
    options: ["Nous allons au marché", "Nous venons au marché", "Nous mangeons au marché", "Nous partons marché"],
    answer: "Nous allons au marché"
  },
  {
    question: "Quelle est la terminaison des verbes du premier groupe ?",
    options: ["-er", "-ir", "-re", "-oir"],
    answer: "-er"
  },
  {
    question: "Comment dit-on 'I play football' ?",
    options: ["Je joue au football", "Je fais du football", "Je cours football", "Je vais football"],
    answer: "Je joue au football"
  },
  {
    question: "Quelle expression est une salutation ?",
    options: ["Bonjour", "Merci", "Faim", "Vélo"],
    answer: "Bonjour"
  },
  {
    question: "Comment écrit-on 'twenty' en français ?",
    options: ["Vingt", "Dix", "Trente", "Quarante"],
    answer: "Vingt"
  },
  {
    question: "Combien font deux plus deux ?",
    options: ["Quatre", "Cinq", "Trois", "Six"],
    answer: "Quatre"
  },
  {
    question: "Quel pronom correspond à 'they' au féminin ?",
    options: ["Elles", "Ils", "Nous", "Vous"],
    answer: "Elles"
  },
  {
    question: "Quel est le mot pour 'school' en français ?",
    options: ["L’école", "La maison", "Le marché", "Le jardin"],
    answer: "L’école"
  },
  {
    question: "Quel temps utilise-t-on pour parler du futur ?",
    options: ["Futur", "Présent", "Passé", "Imparfait"],
    answer: "Futur"
  },
  {
    question: "Comment écrit-on le nombre 100 en français ?",
    options: ["Cent", "Mille", "Dix", "Quatre-vingts"],
    answer: "Cent"
  },
  {
    question: "Que veut dire 'au revoir' ?",
    options: ["Goodbye", "Hello", "Good night", "See you soon"],
    answer: "Goodbye"
  },
  {
    question: "Quel est l’adjectif dans la phrase 'un garçon intelligent' ?",
    options: ["Intelligent", "Un", "Garçon", "Le"],
    answer: "Intelligent"
  },
  {
    question: "Comment demande-t-on 'How are you?' en français ?",
    options: ["Comment ça va ?", "Où est-ce ?", "C’est quoi ?", "Qu’est-ce que tu fais ?"],
    answer: "Comment ça va ?"
  },
  {
    question: "Quel est le verbe dans la phrase 'Elle mange une pomme' ?",
    options: ["Mange", "Elle", "Une", "Pomme"],
    answer: "Mange"
  },
  {
    question: "Quel est l’infinitif de 'mange' ?",
    options: ["Manger", "Mangir", "Mangre", "Mangoir"],
    answer: "Manger"
  },
  {
    question: "Quel est le pronom personnel sujet pour 'nous' en français ?",
    options: ["Je", "Tu", "Il", "Nous"],
    answer: "Nous"
  },
  {
    question: "Comment dit-on 'to eat' en français ?",
    options: ["Manger", "Boire", "Aller", "Venir"],
    answer: "Manger"
  },
  {
    question: "Le mot 'école' est un mot de quel genre ?",
    options: ["Masculin", "Féminin", "Neutre", "Pluriel"],
    answer: "Féminin"
  },
  {
    question: "Quel est l'adjectif possessif pour 'their' en français ?",
    options: ["Mon", "Notre", "Votre", "Leur"],
    answer: "Leur"
  },
  {
    question: "Quel est le passé composé du verbe 'finir' avec 'il' ?",
    options: ["Il finit", "Il a fini", "Il finissait", "Il avait fini"],
    answer: "Il a fini"
  },
  {
    question: "Quel est l'équivalent de 'I am going to the market' ?",
    options: [
      "Je vais au marché",
      "Je vais à la maison",
      "Je vais à l'école",
      "Je vais au parc"
    ],
    answer: "Je vais au marché"
  },
  {
    question: "Quelle est la bonne question pour demander l'heure ?",
    options: [
      "Où est le temps ?",
      "Quelle heure est-il ?",
      "Quel jour est-il ?",
      "Qu'est-ce que c’est ?"
    ],
    answer: "Quelle heure est-il ?"
  },
  {
    question: "Choisissez le bon article défini pour 'ami'.",
    options: ["Le", "La", "L'", "Les"],
    answer: "L'"
  },
  {
    question: "Quelle est la forme correcte de l’impératif pour 'parler' (tu) ?",
    options: ["Parles", "Parle", "Parlez", "Parlons"],
    answer: "Parle"
  },
  {
    question: "Quel est le mot pour 'hospital' en français ?",
    options: ["Hôpital", "Église", "Magasin", "École"],
    answer: "Hôpital"
  },
  {
    question: "Comment dit-on 'father' en français ?",
    options: ["Frère", "Oncle", "Père", "Grand-père"],
    answer: "Père"
  },
  {
    question: "Quel est le contraire de 'petit' ?",
    options: ["Grand", "Lent", "Large", "Beau"],
    answer: "Grand"
  },
  {
    question: "Quel verbe signifie 'to read' ?",
    options: ["Lire", "Écrire", "Parler", "Dormir"],
    answer: "Lire"
  },
  {
    question: "Quelle est la bonne terminaison pour le verbe -er au présent avec 'nous' ?",
    options: ["-ons", "-ez", "-ent", "-e"],
    answer: "-ons"
  },
  {
    question: "Quelle est la traduction de 'Where do you live?'",
    options: [
      "Où es-tu ?",
      "Où habites-tu ?",
      "Comment tu vas ?",
      "Tu fais quoi ?"
    ],
    answer: "Où habites-tu ?"
  },
  {
    question: "Comment écrit-on 91 en français ?",
    options: ["Quatre-vingt-onze", "Nonante-et-un", "Soixante-et-onze", "Quatre-vingt-dix"],
    answer: "Quatre-vingt-onze"
  },
  {
    question: "Le mot 'livre' est masculin ou féminin ?",
    options: ["Masculin", "Féminin", "Pluriel", "Neutre"],
    answer: "Masculin"
  },
  {
    question: "Quelle est la bonne conjugaison du verbe 'avoir' avec 'vous' ?",
    options: ["As", "Avons", "Avez", "Ont"],
    answer: "Avez"
  },
  {
    question: "Comment appelle-t-on un repas du soir ?",
    options: ["Déjeuner", "Dîner", "Petit déjeuner", "Goûter"],
    answer: "Dîner"
  },
  {
    question: "Quel est l'article indéfini de 'école' ?",
    options: ["Un", "Une", "Le", "Des"],
    answer: "Une"
  },
  {
    question: "Comment dit-on 'We are happy' en français ?",
    options: [
      "Nous sommes tristes",
      "Nous avons heureux",
      "Nous sommes heureux",
      "Nous allons bien"
    ],
    answer: "Nous sommes heureux"
  },
  {
    question: "Quel est le pronom complément pour 'me' ?",
    options: ["Te", "Se", "Me", "Le"],
    answer: "Me"
  },
  {
    question: "Comment dit-on 'I like French' ?",
    options: [
      "J'aime le français",
      "Je parle français",
      "Je suis français",
      "Je fais français"
    ],
    answer: "J'aime le français"
  },
  {
    question: "Quel est le féminin de 'acteur' ?",
    options: ["Actrice", "Acteuse", "Acté", "Actoire"],
    answer: "Actrice"
  },
  {
    question: "Quelle préposition utilise-t-on avec une ville ?",
    options: ["à", "en", "au", "dans"],
    answer: "à"
  },
  {
    question: "Comment s'appelle une personne qui enseigne ?",
    options: ["Médecin", "Professeur", "Directeur", "Élève"],
    answer: "Professeur"
  },
  {
    question: "Quel est l'infinitif du verbe conjugué 'ils vont' ?",
    options: ["Aller", "Venir", "Avoir", "Être"],
    answer: "Aller"
  },
  {
    question: "Comment dit-on 'My name is Paul' en français ?",
    options: [
      "Je suis Paul",
      "Mon prénom est Paul",
      "Je m'appelle Paul",
      "Moi c’est Paul"
    ],
    answer: "Je m'appelle Paul"
  },
  {
    question: "Quelle est la bonne expression pour saluer le matin ?",
    options: ["Bonsoir", "Salut", "Bonjour", "Bonne nuit"],
    answer: "Bonjour"
  },
  {
    question: "Quel est le mot pour 'library' ?",
    options: ["Librairie", "Bibliothèque", "École", "Bureau"],
    answer: "Bibliothèque"
  },
  {
    question: "Quel est le synonyme de 'rapide' ?",
    options: ["Vite", "Lent", "Petit", "Dur"],
    answer: "Vite"
  },
  {
    question: "Quelle est la bonne forme de négation ?",
    options: ["Ne...pas", "Ne...plus", "Pas...ne", "Pas...pas"],
    answer: "Ne...pas"
  },
  {
    question: "Quel temps est utilisé pour 'Je chantais' ?",
    options: ["Présent", "Passé composé", "Imparfait", "Futur"],
    answer: "Imparfait"
  },
  {
    question: "Comment dit-on 'We went to school' ?",
    options: [
      "Nous allons à l’école",
      "Nous sommes allés à l’école",
      "Nous irons à l’école",
      "Nous allions à l’école"
    ],
    answer: "Nous sommes allés à l’école"
  },
  {
    question: "Quel est le mot pour 'kitchen' ?",
    options: ["Chambre", "Cuisine", "Salon", "Salle de bain"],
    answer: "Cuisine"
  },
  {
    question: "Quel est le féminin de 'lion' ?",
    options: ["Lione", "Lionesse", "Lionne", "Lionette"],
    answer: "Lionne"
  },
  {
    question: "Quel est le pluriel de 'cheval' ?",
    options: ["Chevals", "Chevaux", "Chevelles", "Cheveau"],
    answer: "Chevaux"
  },
  {
    question: "Comment appelle-t-on le jour après lundi ?",
    options: ["Mardi", "Mercredi", "Dimanche", "Jeudi"],
    answer: "Mardi"
  },
  {
    question: "Quelle saison suit l’hiver ?",
    options: ["Été", "Printemps", "Automne", "Pluie"],
    answer: "Printemps"
  },
  {
    question: "Quel est le mot pour 'notebook' ?",
    options: ["Livre", "Stylo", "Cahier", "Papier"],
    answer: "Cahier"
  },
  {
    question: "Quelle est la forme correcte du futur de 'avoir' (je) ?",
    options: ["J’ai", "J’aurai", "J’avais", "J’avais eu"],
    answer: "J’aurai"
  },
  {
    question: "Quelle est la bonne forme interrogative ?",
    options: ["Est-tu prêt ?", "Tu es prêt ?", "Es-tu prêt ?", "Prêt es-tu ?"],
    answer: "Es-tu prêt ?"
  },
  {
    question: "Quel est le contraire de 'facile' ?",
    options: ["Difficile", "Dur", "Impossible", "Lourd"],
    answer: "Difficile"
  },
  {
    question: "Comment dit-on 'He is tall' ?",
    options: [
      "Il est grand",
      "Il est haut",
      "Il est gros",
      "Il est long"
    ],
    answer: "Il est grand"
  },
  {
    question: "Quel est le verbe pour 'to sleep' ?",
    options: ["Dormir", "Repos", "Sommeiller", "Bouger"],
    answer: "Dormir"
  },
  {
    question: "Quelle est la bonne préposition pour le mois ?",
    options: ["En", "Dans", "Sur", "À"],
    answer: "En"
  },
  {
    question: "Comment demande-t-on l’âge de quelqu’un ?",
    options: [
      "Tu as combien ?",
      "Quel âge as-tu ?",
      "Comment tu t’appelles ?",
      "Combien es-tu ?"
    ],
    answer: "Quel âge as-tu ?"
  },
  {
    question: "Quel est le verbe correct pour 'to go' ?",
    options: ["Aller", "Venir", "Faire", "Avoir"],
    answer: "Aller"
  },
  {
    question: "Comment écrit-on le nombre 100 en français ?",
    options: ["Cinquante", "Soixante", "Cent", "Mille"],
    answer: "Cent"
  },
  {
    question: "Quel est l'antonyme de 'chaud' ?",
    options: ["Froid", "Sec", "Mouillé", "Tiède"],
    answer: "Froid"
  },
  {
    question: "Comment dit-on 'table' en français ?",
    options: ["Chaise", "Table", "Bureau", "Lit"],
    answer: "Table"
  },
  {
    question: "Quelle est la forme négative de 'Je parle français' ?",
    options: [
      "Je ne parle pas français",
      "Je parle ne pas français",
      "Je ne pas parle français",
      "Je ne parle français pas"
    ],
    answer: "Je ne parle pas français"
  },
  {
    question: "Quelle est la conjugaison de 'être' au présent avec 'nous' ?",
    options: ["Sommes", "Sont", "Êtes", "Es"],
    answer: "Sommes"
  },
  {
    question: "Quel pronom remplace 'Marie et moi' ?",
    options: ["Ils", "Elles", "Nous", "Vous"],
    answer: "Nous"
  },
  {
    question: "Lequel est un fruit ?",
    options: ["Pomme", "Pain", "Fromage", "Viande"],
    answer: "Pomme"
  },
  {
    question: "Quel est le pluriel de 'animal' ?",
    options: ["Animaux", "Animals", "Animos", "Animels"],
    answer: "Animaux"
  },
  {
    question: "Comment dit-on 'I have a cat' ?",
    options: [
      "J’ai un chat",
      "Je suis un chat",
      "Je veux un chat",
      "J’aime le chat"
    ],
    answer: "J’ai un chat"
  },
  {
    question: "Quel mot complète correctement : 'Il ___ au travail.' ?",
    options: ["vais", "vas", "va", "allez"],
    answer: "va"
  },
  {
    question: "Le mot 'voiture' est de quel genre ?",
    options: ["Masculin", "Féminin", "Neutre", "Pluriel"],
    answer: "Féminin"
  },
  {
    question: "Quel est le verbe au futur : 'je parlerai' signifie ?",
    options: ["I speak", "I spoke", "I will speak", "I am speaking"],
    answer: "I will speak"
  },
  {
    question: "Comment dit-on 'She is sick' ?",
    options: [
      "Elle est malade",
      "Elle a malade",
      "Elle est bien",
      "Elle va malade"
    ],
    answer: "Elle est malade"
  },
  {
    question: "Quelle est la bonne réponse pour 'Comment tu t'appelles ?'",
    options: [
      "J'ai dix ans",
      "Je m'appelle Marie",
      "Ça va bien",
      "Je suis étudiant"
    ],
    answer: "Je m'appelle Marie"
  },
  {
    question: "Le mot 'fenêtre' signifie :",
    options: ["Porte", "Chaise", "Fenêtre", "Toit"],
    answer: "Fenêtre"
  },
  {
    question: "Quel est l'adverbe de temps dans 'Je suis toujours heureux' ?",
    options: ["Je", "suis", "toujours", "heureux"],
    answer: "toujours"
  },
  {
    question: "Quel mot est un adjectif ?",
    options: ["Rapide", "Courir", "Vitesse", "Course"],
    answer: "Rapide"
  },
  {
    question: "Quel est l'opposé de 'jour' ?",
    options: ["Nuit", "Soir", "Matin", "Midi"],
    answer: "Nuit"
  },
  {
    question: "Quel est le bon mot pour 'kitchen' ?",
    options: ["Cuisine", "Salon", "Salle", "Garage"],
    answer: "Cuisine"
  },
  {
    question: "Quelle est la forme correcte de 'nous + finir' au présent ?",
    options: ["Nous finis", "Nous finissons", "Nous finira", "Nous finit"],
    answer: "Nous finissons"
  },
  {
    question: "Quel est le passé composé de 'venir' avec 'elle' ?",
    options: ["Elle venue", "Elle est venue", "Elle a venu", "Elle était venue"],
    answer: "Elle est venue"
  },
  {
    question: "Quel mot est un moyen de transport ?",
    options: ["Avion", "École", "Jardin", "Bouteille"],
    answer: "Avion"
  },
  {
    question: "Quelle phrase est correcte ?",
    options: [
      "Il parlent vite",
      "Ils parlent vite",
      "Il parle vite",
      "Ils parle vite"
    ],
    answer: "Ils parlent vite"
  },
  {
    question: "Quel est l'adjectif pour décrire un bébé ?",
    options: ["Petit", "Rapide", "Sombre", "Grand"],
    answer: "Petit"
  },
  {
    question: "Que signifie 'bleu' ?",
    options: ["Une couleur", "Une fleur", "Un animal", "Une voiture"],
    answer: "Une couleur"
  },
  {
    question: "Comment dit-on 'They are friends' ?",
    options: [
      "Ils sont amis",
      "Ils est amis",
      "Ils sont ami",
      "Ils sont le ami"
    ],
    answer: "Ils sont amis"
  },
  {
    question: "Quel est le féminin de 'étudiant' ?",
    options: ["Étudiante", "Étudieuse", "Étudiée", "Étudière"],
    answer: "Étudiante"
  },
  {
    question: "Comment exprimer la possession : 'my book' ?",
    options: ["Mon livre", "Ma livre", "Le livre", "Un livre"],
    answer: "Mon livre"
  },
  {
    question: "Quelle est l'heure correcte : 'Il est midi' signifie ?",
    options: ["12h00", "00h00", "14h00", "10h00"],
    answer: "12h00"
  },
  {
    question: "Quel verbe est irrégulier ?",
    options: ["Avoir", "Finir", "Parler", "Chercher"],
    answer: "Avoir"
  },
  {
    question: "Quel jour vient après jeudi ?",
    options: ["Vendredi", "Mercredi", "Samedi", "Dimanche"],
    answer: "Vendredi"
  },
  {
    question: "Quel est le mot pour 'school bag' ?",
    options: ["Cartable", "Sac à main", "Valise", "Boîte"],
    answer: "Cartable"
  },
  {
    question: "Comment dit-on 'I am tired' ?",
    options: [
      "Je suis fatigué",
      "J'ai fatigué",
      "Je fatigué",
      "Je fatigue"
    ],
    answer: "Je suis fatigué"
  },
  {
    question: "Quel est le pluriel de 'journal' ?",
    options: ["Journaux", "Journals", "Journalistes", "Journeaux"],
    answer: "Journaux"
  },
  {
    question: "Quelle est la traduction de 'I will come tomorrow' ?",
    options: [
      "Je viendrai demain",
      "Je suis venu demain",
      "Je viens demain",
      "Je vais demain"
    ],
    answer: "Je viendrai demain"
  },
  {
    question: "Comment appelle-t-on une personne qui soigne les malades ?",
    options: ["Médecin", "Avocat", "Professeur", "Boulanger"],
    answer: "Médecin"
  },
  {
    question: "Quel est le genre de 'chaise' ?",
    options: ["Féminin", "Masculin", "Pluriel", "Neutre"],
    answer: "Féminin"
  },
  {
    question: "Quel est le bon pronom pour remplacer 'le garçon' ?",
    options: ["Il", "Elle", "Ils", "Nous"],
    answer: "Il"
  },
  {
    question: "Quel est le bon ordre des mots : 'souvent / je / lis / livres' ?",
    options: [
      "Je lis souvent des livres",
      "Je souvent lis des livres",
      "Souvent je lis livres",
      "Lis je souvent des livres"
    ],
    answer: "Je lis souvent des livres"
  },
  {
    question: "Quel mot complète : 'Tu ___ un stylo.' ?",
    options: ["as", "est", "es", "a"],
    answer: "as"
  },
  {
    question: "Quel est l'antonyme de 'fort' ?",
    options: ["Faible", "Lent", "Petit", "Froid"],
    answer: "Faible"
  },
  {
    question: "Quel est le féminin de 'directeur' ?",
    options: ["Directrice", "Direction", "Directeuse", "Dirigeante"],
    answer: "Directrice"
  },
  {
    question: "Comment demande-t-on le prix de quelque chose ?",
    options: [
      "Combien ça coûte ?",
      "Où est le prix ?",
      "Quel prix ?",
      "Qu'est-ce que c’est ?"
    ],
    answer: "Combien ça coûte ?"
  },
  {
    question: "Quel mot est un adjectif de couleur ?",
    options: ["Rouge", "Course", "Parle", "Boire"],
    answer: "Rouge"
  },
  {
    question: "Quel est le verbe pour 'to listen' ?",
    options: ["Écouter", "Regarder", "Voir", "Lire"],
    answer: "Écouter"
  },
  {
    question: "Quelle est la bonne terminaison pour les verbes -re avec 'il' ?",
    options: ["-", "-t", "-d", "-s"],
    answer: "-"
  }
];

export default jhsfrenchQuestions;